//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface ICalculatedFieldClient {
    get(companyId: string): Observable<CompanyCalculatedFieldConfiguration>;
    getByJobId(jobId: string): Observable<CompanyCalculatedFieldConfiguration>;
    post(companyCalculatedFieldConfiguration: CompanyCalculatedFieldConfiguration): Observable<void>;
}

@Injectable()
export class CalculatedFieldClient implements ICalculatedFieldClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(companyId: string): Observable<CompanyCalculatedFieldConfiguration> {
        let url_ = this.baseUrl + "/api/CalculatedField/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyCalculatedFieldConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyCalculatedFieldConfiguration>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompanyCalculatedFieldConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyCalculatedFieldConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByJobId(jobId: string): Observable<CompanyCalculatedFieldConfiguration> {
        let url_ = this.baseUrl + "/api/CalculatedField/getByJobId/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyCalculatedFieldConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyCalculatedFieldConfiguration>;
        }));
    }

    protected processGetByJobId(response: HttpResponseBase): Observable<CompanyCalculatedFieldConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyCalculatedFieldConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(companyCalculatedFieldConfiguration: CompanyCalculatedFieldConfiguration): Observable<void> {
        let url_ = this.baseUrl + "/api/CalculatedField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(companyCalculatedFieldConfiguration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyAssociationRequestClient {
    get(): Observable<CompanyAssociationRequest[]>;
    post(request: CompanyAssociationRequest): Observable<void>;
    getById(id: string): Observable<CompanyAssociationRequest>;
    delete(id: string): Observable<void>;
    approve(id: string): Observable<void>;
    reject(id: string, reason: RejectViewModel): Observable<void>;
    getPendingRequestsForUser(userId: string): Observable<CompanyAssociationRequest[]>;
}

@Injectable()
export class CompanyAssociationRequestClient implements ICompanyAssociationRequestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<CompanyAssociationRequest[]> {
        let url_ = this.baseUrl + "/api/CompanyAssociationRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyAssociationRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyAssociationRequest[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompanyAssociationRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyAssociationRequest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(request: CompanyAssociationRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/CompanyAssociationRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<CompanyAssociationRequest> {
        let url_ = this.baseUrl + "/api/CompanyAssociationRequest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyAssociationRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyAssociationRequest>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CompanyAssociationRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyAssociationRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/CompanyAssociationRequest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approve(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/CompanyAssociationRequest/approve/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reject(id: string, reason: RejectViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/CompanyAssociationRequest/reject/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reason);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingRequestsForUser(userId: string): Observable<CompanyAssociationRequest[]> {
        let url_ = this.baseUrl + "/api/CompanyAssociationRequest/pending/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingRequestsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingRequestsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyAssociationRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyAssociationRequest[]>;
        }));
    }

    protected processGetPendingRequestsForUser(response: HttpResponseBase): Observable<CompanyAssociationRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyAssociationRequest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyClient {
    get(): Observable<Company[]>;
    post(company: Company): Observable<void>;
    getById(id: string): Observable<Company>;
    put(id: string, company: Company): Observable<void>;
    delete(id: string): Observable<void>;
    getCompanyNames(): Observable<CompanyNameViewModel[]>;
    getCompanyNamesForUser(): Observable<CompanyNameViewModel[]>;
    getVendorCompanyNames(): Observable<CompanyNameViewModel[]>;
    getConsumerCompanyNames(): Observable<CompanyNameViewModel[]>;
    getCompanyContactInfo(id: string): Observable<CompanyContactInfo>;
}

@Injectable()
export class CompanyClient implements ICompanyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<Company[]> {
        let url_ = this.baseUrl + "/api/Company";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Company[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Company[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Company[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Company.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(company: Company): Observable<void> {
        let url_ = this.baseUrl + "/api/Company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(company);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<Company> {
        let url_ = this.baseUrl + "/api/Company/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Company>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Company>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<Company> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Company.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(id: string, company: Company): Observable<void> {
        let url_ = this.baseUrl + "/api/Company/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(company);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Company/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCompanyNames(): Observable<CompanyNameViewModel[]> {
        let url_ = this.baseUrl + "/api/Company/names";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyNameViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyNameViewModel[]>;
        }));
    }

    protected processGetCompanyNames(response: HttpResponseBase): Observable<CompanyNameViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyNameViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCompanyNamesForUser(): Observable<CompanyNameViewModel[]> {
        let url_ = this.baseUrl + "/api/Company/namesforuser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyNamesForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyNamesForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyNameViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyNameViewModel[]>;
        }));
    }

    protected processGetCompanyNamesForUser(response: HttpResponseBase): Observable<CompanyNameViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyNameViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVendorCompanyNames(): Observable<CompanyNameViewModel[]> {
        let url_ = this.baseUrl + "/api/Company/vendors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorCompanyNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorCompanyNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyNameViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyNameViewModel[]>;
        }));
    }

    protected processGetVendorCompanyNames(response: HttpResponseBase): Observable<CompanyNameViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyNameViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConsumerCompanyNames(): Observable<CompanyNameViewModel[]> {
        let url_ = this.baseUrl + "/api/Company/consumers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumerCompanyNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumerCompanyNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyNameViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyNameViewModel[]>;
        }));
    }

    protected processGetConsumerCompanyNames(response: HttpResponseBase): Observable<CompanyNameViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyNameViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCompanyContactInfo(id: string): Observable<CompanyContactInfo> {
        let url_ = this.baseUrl + "/api/Company/{id}/contacts";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyContactInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyContactInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyContactInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyContactInfo>;
        }));
    }

    protected processGetCompanyContactInfo(response: HttpResponseBase): Observable<CompanyContactInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyContactInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyWorkbookConfigurationClient {
    getWorkbookActivityOptions(): Observable<string[]>;
    getWellKnownMeasurements(): Observable<WellKnownMeasurementChoice[]>;
    getConfigurationForCompany(companyId: string): Observable<CompanyWorkbookConfiguration>;
    deleteByCompanyId(companyId: string): Observable<void>;
    getConfigurationById(id: string): Observable<CompanyWorkbookConfiguration>;
    getDefaultConfigurationForCompany(companyId: string): Observable<CompanyWorkbookConfiguration>;
    createOrUpdate(companyWorkbookConfiguration: CompanyWorkbookConfiguration): Observable<void>;
}

@Injectable()
export class CompanyWorkbookConfigurationClient implements ICompanyWorkbookConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getWorkbookActivityOptions(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/CompanyWorkbookConfiguration/activities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkbookActivityOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkbookActivityOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetWorkbookActivityOptions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWellKnownMeasurements(): Observable<WellKnownMeasurementChoice[]> {
        let url_ = this.baseUrl + "/api/CompanyWorkbookConfiguration/wellknown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWellKnownMeasurements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWellKnownMeasurements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellKnownMeasurementChoice[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellKnownMeasurementChoice[]>;
        }));
    }

    protected processGetWellKnownMeasurements(response: HttpResponseBase): Observable<WellKnownMeasurementChoice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellKnownMeasurementChoice.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConfigurationForCompany(companyId: string): Observable<CompanyWorkbookConfiguration> {
        let url_ = this.baseUrl + "/api/CompanyWorkbookConfiguration/company/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfigurationForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfigurationForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyWorkbookConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyWorkbookConfiguration>;
        }));
    }

    protected processGetConfigurationForCompany(response: HttpResponseBase): Observable<CompanyWorkbookConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyWorkbookConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteByCompanyId(companyId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/CompanyWorkbookConfiguration/company/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByCompanyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByCompanyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteByCompanyId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConfigurationById(id: string): Observable<CompanyWorkbookConfiguration> {
        let url_ = this.baseUrl + "/api/CompanyWorkbookConfiguration/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfigurationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfigurationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyWorkbookConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyWorkbookConfiguration>;
        }));
    }

    protected processGetConfigurationById(response: HttpResponseBase): Observable<CompanyWorkbookConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyWorkbookConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDefaultConfigurationForCompany(companyId: string): Observable<CompanyWorkbookConfiguration> {
        let url_ = this.baseUrl + "/api/CompanyWorkbookConfiguration/default/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultConfigurationForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultConfigurationForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyWorkbookConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyWorkbookConfiguration>;
        }));
    }

    protected processGetDefaultConfigurationForCompany(response: HttpResponseBase): Observable<CompanyWorkbookConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyWorkbookConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrUpdate(companyWorkbookConfiguration: CompanyWorkbookConfiguration): Observable<void> {
        let url_ = this.baseUrl + "/api/CompanyWorkbookConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(companyWorkbookConfiguration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IConfigClient {
    get(): Observable<UIConfig>;
    ping(): Observable<boolean>;
    getTelemetryConfiguration(): Observable<FileResponse | null>;
    testCreateException(): Observable<FileResponse | null>;
}

@Injectable()
export class ConfigClient implements IConfigClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<UIConfig> {
        let url_ = this.baseUrl + "/api/Config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UIConfig>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UIConfig>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UIConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UIConfig.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    ping(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Config/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTelemetryConfiguration(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Config/telmeteryconfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTelemetryConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTelemetryConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetTelemetryConfiguration(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testCreateException(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Config/testexception";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestCreateException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestCreateException(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processTestCreateException(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IConsumerJobClient {
    getConsumerJobById(id: string): Observable<ConsumerJob>;
    deleteConsumerJob(id: string): Observable<void>;
    getConsumerJobs(companyId: string, newerThan: Date | null | undefined): Observable<ConsumerJob[]>;
    getConsumerJobsCount(companyId: string): Observable<number>;
    associateVendorToConsumerJob(consumerJobId: string, vendorId: string): Observable<void>;
    deassociateVendorToConsumerJob(consumerJobId: string, vendorId: string): Observable<void>;
    deassociateVendorJobToConsumerJob(consumerJobId: string, vendorJobId: string): Observable<void>;
    updateConsumerJob(consumerJob: ConsumerJob): Observable<void>;
    getDashboardLink(jobId: string): Observable<string>;
}

@Injectable()
export class ConsumerJobClient implements IConsumerJobClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getConsumerJobById(id: string): Observable<ConsumerJob> {
        let url_ = this.baseUrl + "/api/ConsumerJob/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumerJobById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumerJobById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsumerJob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsumerJob>;
        }));
    }

    protected processGetConsumerJobById(response: HttpResponseBase): Observable<ConsumerJob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsumerJob.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteConsumerJob(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ConsumerJob/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsumerJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsumerJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsumerJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConsumerJobs(companyId: string, newerThan: Date | null | undefined): Observable<ConsumerJob[]> {
        let url_ = this.baseUrl + "/api/ConsumerJob/company/{companyId}/newerThan?";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (newerThan !== undefined && newerThan !== null)
            url_ += "newerThan=" + encodeURIComponent(newerThan ? "" + newerThan.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumerJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumerJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsumerJob[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsumerJob[]>;
        }));
    }

    protected processGetConsumerJobs(response: HttpResponseBase): Observable<ConsumerJob[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsumerJob.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConsumerJobsCount(companyId: string): Observable<number> {
        let url_ = this.baseUrl + "/api/ConsumerJob/company/{companyId}/count";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumerJobsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumerJobsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetConsumerJobsCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    associateVendorToConsumerJob(consumerJobId: string, vendorId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ConsumerJob/associateVendor/{consumerJobId}/{vendorId}";
        if (consumerJobId === undefined || consumerJobId === null)
            throw new globalThis.Error("The parameter 'consumerJobId' must be defined.");
        url_ = url_.replace("{consumerJobId}", encodeURIComponent("" + consumerJobId));
        if (vendorId === undefined || vendorId === null)
            throw new globalThis.Error("The parameter 'vendorId' must be defined.");
        url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateVendorToConsumerJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateVendorToConsumerJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssociateVendorToConsumerJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deassociateVendorToConsumerJob(consumerJobId: string, vendorId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ConsumerJob/deassociateVendor/{consumerJobId}/{vendorId}";
        if (consumerJobId === undefined || consumerJobId === null)
            throw new globalThis.Error("The parameter 'consumerJobId' must be defined.");
        url_ = url_.replace("{consumerJobId}", encodeURIComponent("" + consumerJobId));
        if (vendorId === undefined || vendorId === null)
            throw new globalThis.Error("The parameter 'vendorId' must be defined.");
        url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeassociateVendorToConsumerJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeassociateVendorToConsumerJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeassociateVendorToConsumerJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deassociateVendorJobToConsumerJob(consumerJobId: string, vendorJobId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ConsumerJob/deassociateVendorJob/{consumerJobId}/{vendorJobId}";
        if (consumerJobId === undefined || consumerJobId === null)
            throw new globalThis.Error("The parameter 'consumerJobId' must be defined.");
        url_ = url_.replace("{consumerJobId}", encodeURIComponent("" + consumerJobId));
        if (vendorJobId === undefined || vendorJobId === null)
            throw new globalThis.Error("The parameter 'vendorJobId' must be defined.");
        url_ = url_.replace("{vendorJobId}", encodeURIComponent("" + vendorJobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeassociateVendorJobToConsumerJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeassociateVendorJobToConsumerJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeassociateVendorJobToConsumerJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateConsumerJob(consumerJob: ConsumerJob): Observable<void> {
        let url_ = this.baseUrl + "/api/ConsumerJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consumerJob);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsumerJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsumerJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateConsumerJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDashboardLink(jobId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/ConsumerJob/dashboardlink/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDashboardLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDeviceClient {
    get(includeDeleted: boolean | undefined): Observable<Device[]>;
    post(device: Device): Observable<void>;
    getById(id: string): Observable<Device>;
    put(id: string, device: Device): Observable<void>;
    delete(id: string): Observable<void>;
    undelete(id: string): Observable<void>;
    getDevicesForCompany(companyId: string): Observable<Device[]>;
    getDeviceJobMappingForCompany(companyId: string, startDate: Date, enddate: Date): Observable<DeviceJobMapping[]>;
    getDevicesForCompanyIncludingDeleted(companyId: string): Observable<Device[]>;
    getLatestDeviceDiagnostics(companyId: string | null | undefined, hours: number | undefined): Observable<DeviceDiagnosticViewModel[]>;
}

@Injectable()
export class DeviceClient implements IDeviceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(includeDeleted: boolean | undefined): Observable<Device[]> {
        let url_ = this.baseUrl + "/api/Device?";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Device[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Device[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Device[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Device.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(device: Device): Observable<void> {
        let url_ = this.baseUrl + "/api/Device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<Device> {
        let url_ = this.baseUrl + "/api/Device/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Device>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Device>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<Device> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Device.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(id: string, device: Device): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    undelete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/{id}/undelete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUndelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDevicesForCompany(companyId: string): Observable<Device[]> {
        let url_ = this.baseUrl + "/api/Device/company/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevicesForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevicesForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Device[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Device[]>;
        }));
    }

    protected processGetDevicesForCompany(response: HttpResponseBase): Observable<Device[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Device.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDeviceJobMappingForCompany(companyId: string, startDate: Date, enddate: Date): Observable<DeviceJobMapping[]> {
        let url_ = this.baseUrl + "/api/Device/company/{companyId}/start/{startDate}/end/{enddate}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
        if (enddate === undefined || enddate === null)
            throw new globalThis.Error("The parameter 'enddate' must be defined.");
        url_ = url_.replace("{enddate}", encodeURIComponent(enddate ? "" + enddate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeviceJobMappingForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeviceJobMappingForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeviceJobMapping[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeviceJobMapping[]>;
        }));
    }

    protected processGetDeviceJobMappingForCompany(response: HttpResponseBase): Observable<DeviceJobMapping[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceJobMapping.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDevicesForCompanyIncludingDeleted(companyId: string): Observable<Device[]> {
        let url_ = this.baseUrl + "/api/Device/companyWithDeleted/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevicesForCompanyIncludingDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevicesForCompanyIncludingDeleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Device[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Device[]>;
        }));
    }

    protected processGetDevicesForCompanyIncludingDeleted(response: HttpResponseBase): Observable<Device[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Device.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLatestDeviceDiagnostics(companyId: string | null | undefined, hours: number | undefined): Observable<DeviceDiagnosticViewModel[]> {
        let url_ = this.baseUrl + "/api/Device/diagnostics/latest?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (hours === null)
            throw new globalThis.Error("The parameter 'hours' cannot be null.");
        else if (hours !== undefined)
            url_ += "hours=" + encodeURIComponent("" + hours) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestDeviceDiagnostics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestDeviceDiagnostics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeviceDiagnosticViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeviceDiagnosticViewModel[]>;
        }));
    }

    protected processGetLatestDeviceDiagnostics(response: HttpResponseBase): Observable<DeviceDiagnosticViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceDiagnosticViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDynamicWorkbookClient {
    getByJobNumber(jobNumber: string | null | undefined): Observable<any[]>;
    get(clientId: string): Observable<FileResponse | null>;
    put(clientId: string, dynamicWorkbook: any): Observable<void>;
}

@Injectable()
export class DynamicWorkbookClient implements IDynamicWorkbookClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getByJobNumber(jobNumber: string | null | undefined): Observable<any[]> {
        let url_ = this.baseUrl + "/api/DynamicWorkbook?";
        if (jobNumber !== undefined && jobNumber !== null)
            url_ += "jobNumber=" + encodeURIComponent("" + jobNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByJobNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByJobNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processGetByJobNumber(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(clientId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DynamicWorkbook/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new globalThis.Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(clientId: string, dynamicWorkbook: any): Observable<void> {
        let url_ = this.baseUrl + "/api/DynamicWorkbook/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new globalThis.Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dynamicWorkbook);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFeaturesClient {
    isFeatureEnabled(feature: string): Observable<boolean>;
    getFeatures(): Observable<string[]>;
}

@Injectable()
export class FeaturesClient implements IFeaturesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    isFeatureEnabled(feature: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Features/{feature}";
        if (feature === undefined || feature === null)
            throw new globalThis.Error("The parameter 'feature' must be defined.");
        url_ = url_.replace("{feature}", encodeURIComponent("" + feature));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsFeatureEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsFeatureEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsFeatureEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFeatures(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Features";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetFeatures(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFilesClient {
    getFileSasToken(blob: string | null | undefined): Observable<FileSasTokenResult>;
    list(directory: string | null | undefined, maxResults: number | undefined): Observable<FilesListResult>;
}

@Injectable()
export class FilesClient implements IFilesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getFileSasToken(blob: string | null | undefined): Observable<FileSasTokenResult> {
        let url_ = this.baseUrl + "/api/Files/filetoken?";
        if (blob !== undefined && blob !== null)
            url_ += "blob=" + encodeURIComponent("" + blob) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileSasToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileSasToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileSasTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileSasTokenResult>;
        }));
    }

    protected processGetFileSasToken(response: HttpResponseBase): Observable<FileSasTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSasTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    list(directory: string | null | undefined, maxResults: number | undefined): Observable<FilesListResult> {
        let url_ = this.baseUrl + "/api/Files/list?";
        if (directory !== undefined && directory !== null)
            url_ += "directory=" + encodeURIComponent("" + directory) + "&";
        if (maxResults === null)
            throw new globalThis.Error("The parameter 'maxResults' cannot be null.");
        else if (maxResults !== undefined)
            url_ += "maxResults=" + encodeURIComponent("" + maxResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilesListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilesListResult>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<FilesListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilesListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IImportClient {
    importCsv(file: FileParameter | null | undefined, jobId: string | null | undefined, timeOffset: number | null | undefined): Observable<void>;
    getImportsForJob(jobId: string): Observable<CsvJobImport[]>;
    removeImport(jobId: string, name: string): Observable<void>;
}

@Injectable()
export class ImportClient implements IImportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    importCsv(file: FileParameter | null | undefined, jobId: string | null | undefined, timeOffset: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Import/csv?";
        if (jobId !== undefined && jobId !== null)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (timeOffset !== undefined && timeOffset !== null)
            url_ += "timeOffset=" + encodeURIComponent("" + timeOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportCsv(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImportsForJob(jobId: string): Observable<CsvJobImport[]> {
        let url_ = this.baseUrl + "/api/Import/csv/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportsForJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportsForJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CsvJobImport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CsvJobImport[]>;
        }));
    }

    protected processGetImportsForJob(response: HttpResponseBase): Observable<CsvJobImport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CsvJobImport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeImport(jobId: string, name: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Import/csv/{jobId}/{name}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IIngestionClient {
    post(measurment: IncomingMeasurment): Observable<void>;
}

@Injectable()
export class IngestionClient implements IIngestionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    post(measurment: IncomingMeasurment): Observable<void> {
        let url_ = this.baseUrl + "/api/Ingestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(measurment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IJobIntegrationClient {
    getAll(): Observable<JobIntegration[]>;
    create(jobIntegration: JobIntegration): Observable<JobIntegration>;
    getById(id: string): Observable<JobIntegration>;
    update(id: string, jobIntegration: JobIntegration): Observable<JobIntegration>;
    delete(id: string): Observable<FileResponse | null>;
    getByCompanyId(companyId: string): Observable<JobIntegration[]>;
    getByJobId(jobId: string): Observable<JobIntegration[]>;
    getActiveIntegrations(companyId: string | null | undefined): Observable<JobIntegration[]>;
    getActiveJobsWithoutIntegrations(companyId: string | null | undefined): Observable<VendorJob[]>;
}

@Injectable()
export class JobIntegrationClient implements IJobIntegrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<JobIntegration[]> {
        let url_ = this.baseUrl + "/api/JobIntegration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobIntegration[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobIntegration[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<JobIntegration[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobIntegration.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(jobIntegration: JobIntegration): Observable<JobIntegration> {
        let url_ = this.baseUrl + "/api/JobIntegration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobIntegration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobIntegration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobIntegration>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<JobIntegration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobIntegration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<JobIntegration> {
        let url_ = this.baseUrl + "/api/JobIntegration/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobIntegration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobIntegration>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<JobIntegration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobIntegration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, jobIntegration: JobIntegration): Observable<JobIntegration> {
        let url_ = this.baseUrl + "/api/JobIntegration/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobIntegration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobIntegration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobIntegration>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<JobIntegration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobIntegration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/JobIntegration/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByCompanyId(companyId: string): Observable<JobIntegration[]> {
        let url_ = this.baseUrl + "/api/JobIntegration/company/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCompanyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCompanyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobIntegration[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobIntegration[]>;
        }));
    }

    protected processGetByCompanyId(response: HttpResponseBase): Observable<JobIntegration[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobIntegration.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByJobId(jobId: string): Observable<JobIntegration[]> {
        let url_ = this.baseUrl + "/api/JobIntegration/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobIntegration[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobIntegration[]>;
        }));
    }

    protected processGetByJobId(response: HttpResponseBase): Observable<JobIntegration[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobIntegration.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveIntegrations(companyId: string | null | undefined): Observable<JobIntegration[]> {
        let url_ = this.baseUrl + "/api/JobIntegration/active?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveIntegrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveIntegrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobIntegration[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobIntegration[]>;
        }));
    }

    protected processGetActiveIntegrations(response: HttpResponseBase): Observable<JobIntegration[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobIntegration.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveJobsWithoutIntegrations(companyId: string | null | undefined): Observable<VendorJob[]> {
        let url_ = this.baseUrl + "/api/JobIntegration/jobs/without-integrations?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveJobsWithoutIntegrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveJobsWithoutIntegrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorJob[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorJob[]>;
        }));
    }

    protected processGetActiveJobsWithoutIntegrations(response: HttpResponseBase): Observable<VendorJob[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorJob.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IJobLinkerClient {
    get(): Observable<JobLinker[]>;
    create(jobLinker: JobLinker): Observable<void>;
    update(id: string, jobLinker: JobLinker): Observable<void>;
    delete(id: string): Observable<void>;
    findBestFitOrCreate(job: VendorJob): Observable<JobLinker>;
    getJobLinkerByVendorId(id: string): Observable<JobLinker>;
    associateVendorJobToJobLinkerAsyc(id: string, jobLinker: JobLinker): Observable<void>;
}

@Injectable()
export class JobLinkerClient implements IJobLinkerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<JobLinker[]> {
        let url_ = this.baseUrl + "/api/JobLinker";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLinker[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLinker[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<JobLinker[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobLinker.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(jobLinker: JobLinker): Observable<void> {
        let url_ = this.baseUrl + "/api/JobLinker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobLinker);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, jobLinker: JobLinker): Observable<void> {
        let url_ = this.baseUrl + "/api/JobLinker/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobLinker);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/JobLinker/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findBestFitOrCreate(job: VendorJob): Observable<JobLinker> {
        let url_ = this.baseUrl + "/api/JobLinker/bestfit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(job);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindBestFitOrCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindBestFitOrCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLinker>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLinker>;
        }));
    }

    protected processFindBestFitOrCreate(response: HttpResponseBase): Observable<JobLinker> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobLinker.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getJobLinkerByVendorId(id: string): Observable<JobLinker> {
        let url_ = this.baseUrl + "/api/JobLinker/vendor/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobLinkerByVendorId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobLinkerByVendorId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLinker>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLinker>;
        }));
    }

    protected processGetJobLinkerByVendorId(response: HttpResponseBase): Observable<JobLinker> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobLinker.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    associateVendorJobToJobLinkerAsyc(id: string, jobLinker: JobLinker): Observable<void> {
        let url_ = this.baseUrl + "/api/JobLinker/assoicate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobLinker);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateVendorJobToJobLinkerAsyc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateVendorJobToJobLinkerAsyc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssociateVendorJobToJobLinkerAsyc(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IJobTicketClient {
    getJobTicketsForJob(jobId: string | null | undefined): Observable<Ticket[]>;
    getUploadUrl(jobId: string | null | undefined, name: string | null | undefined): Observable<string>;
    getDownloadZip(jobId: string, token: string | null | undefined): Observable<FileResponse | null>;
}

@Injectable()
export class JobTicketClient implements IJobTicketClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getJobTicketsForJob(jobId: string | null | undefined): Observable<Ticket[]> {
        let url_ = this.baseUrl + "/api/JobTicket?";
        if (jobId !== undefined && jobId !== null)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobTicketsForJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobTicketsForJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Ticket[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Ticket[]>;
        }));
    }

    protected processGetJobTicketsForJob(response: HttpResponseBase): Observable<Ticket[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ticket.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUploadUrl(jobId: string | null | undefined, name: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/JobTicket/uploadUrl?";
        if (jobId !== undefined && jobId !== null)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUploadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDownloadZip(jobId: string, token: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/JobTicket/downloadzip/{jobId}?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadZip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadZip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetDownloadZip(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IJobWorkbookConfigurationClient {
    getWorkbookConfigurationByJobId(jobId: string): Observable<JobWorkbookConfiguration>;
    createDefaultJobWorkbookConfigurationFromCompany(companyId: string | null | undefined, companyUnitSystem: string | null | undefined, jobId: string | null | undefined, jobType: string | null | undefined): Observable<JobWorkbookConfiguration>;
    addOrUpdateJobWorkbookConfiguration(jobWorkbookConfiguration: JobWorkbookConfiguration): Observable<void>;
}

@Injectable()
export class JobWorkbookConfigurationClient implements IJobWorkbookConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getWorkbookConfigurationByJobId(jobId: string): Observable<JobWorkbookConfiguration> {
        let url_ = this.baseUrl + "/api/JobWorkbookConfiguration/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkbookConfigurationByJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkbookConfigurationByJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobWorkbookConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobWorkbookConfiguration>;
        }));
    }

    protected processGetWorkbookConfigurationByJobId(response: HttpResponseBase): Observable<JobWorkbookConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobWorkbookConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDefaultJobWorkbookConfigurationFromCompany(companyId: string | null | undefined, companyUnitSystem: string | null | undefined, jobId: string | null | undefined, jobType: string | null | undefined): Observable<JobWorkbookConfiguration> {
        let url_ = this.baseUrl + "/api/JobWorkbookConfiguration/default?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (companyUnitSystem !== undefined && companyUnitSystem !== null)
            url_ += "companyUnitSystem=" + encodeURIComponent("" + companyUnitSystem) + "&";
        if (jobId !== undefined && jobId !== null)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (jobType !== undefined && jobType !== null)
            url_ += "jobType=" + encodeURIComponent("" + jobType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDefaultJobWorkbookConfigurationFromCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDefaultJobWorkbookConfigurationFromCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobWorkbookConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobWorkbookConfiguration>;
        }));
    }

    protected processCreateDefaultJobWorkbookConfigurationFromCompany(response: HttpResponseBase): Observable<JobWorkbookConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobWorkbookConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateJobWorkbookConfiguration(jobWorkbookConfiguration: JobWorkbookConfiguration): Observable<void> {
        let url_ = this.baseUrl + "/api/JobWorkbookConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobWorkbookConfiguration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateJobWorkbookConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateJobWorkbookConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateJobWorkbookConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INewCompanyRequestClient {
    get(): Observable<NewCompanyRequest[]>;
    post(request: NewCompanyRequest): Observable<void>;
    getById(id: string): Observable<NewCompanyRequest>;
    delete(id: string): Observable<void>;
    approve(id: string): Observable<void>;
    reject(id: string, reason: RejectViewModel): Observable<void>;
    getPendingRequestsForUser(userId: string): Observable<NewCompanyRequest[]>;
}

@Injectable()
export class NewCompanyRequestClient implements INewCompanyRequestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<NewCompanyRequest[]> {
        let url_ = this.baseUrl + "/api/NewCompanyRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewCompanyRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewCompanyRequest[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NewCompanyRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewCompanyRequest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(request: NewCompanyRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/NewCompanyRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<NewCompanyRequest> {
        let url_ = this.baseUrl + "/api/NewCompanyRequest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewCompanyRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewCompanyRequest>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<NewCompanyRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewCompanyRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/NewCompanyRequest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approve(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/NewCompanyRequest/approve/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reject(id: string, reason: RejectViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/NewCompanyRequest/reject/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reason);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingRequestsForUser(userId: string): Observable<NewCompanyRequest[]> {
        let url_ = this.baseUrl + "/api/NewCompanyRequest/pending/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingRequestsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingRequestsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewCompanyRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewCompanyRequest[]>;
        }));
    }

    protected processGetPendingRequestsForUser(response: HttpResponseBase): Observable<NewCompanyRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewCompanyRequest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportsClient {
    getCompanyUsersReport(jobId: string | null | undefined, beginTime: Date | undefined, endTime: Date | undefined, token: string | null | undefined): Observable<FileResponse | null>;
    getSandReport(jobId: string, beginTime: Date | undefined, endTime: Date | undefined, token: string | null | undefined): Observable<FileResponse | null>;
    getDataSheetReport(jobId: string, beginTime: Date | undefined, endTime: Date | undefined, token: string | null | undefined): Observable<FileResponse | null>;
    getPostJobAnalysisReport(jobIds: string[] | null | undefined): Observable<FileResponse | null>;
}

@Injectable()
export class ReportsClient implements IReportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCompanyUsersReport(jobId: string | null | undefined, beginTime: Date | undefined, endTime: Date | undefined, token: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Reports/companyusers?";
        if (jobId !== undefined && jobId !== null)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (beginTime === null)
            throw new globalThis.Error("The parameter 'beginTime' cannot be null.");
        else if (beginTime !== undefined)
            url_ += "beginTime=" + encodeURIComponent(beginTime ? "" + beginTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyUsersReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyUsersReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetCompanyUsersReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSandReport(jobId: string, beginTime: Date | undefined, endTime: Date | undefined, token: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Reports/sand/{jobId}?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (beginTime === null)
            throw new globalThis.Error("The parameter 'beginTime' cannot be null.");
        else if (beginTime !== undefined)
            url_ += "beginTime=" + encodeURIComponent(beginTime ? "" + beginTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSandReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSandReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetSandReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataSheetReport(jobId: string, beginTime: Date | undefined, endTime: Date | undefined, token: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Reports/datasheet/{jobId}?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (beginTime === null)
            throw new globalThis.Error("The parameter 'beginTime' cannot be null.");
        else if (beginTime !== undefined)
            url_ += "beginTime=" + encodeURIComponent(beginTime ? "" + beginTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataSheetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataSheetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetDataSheetReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPostJobAnalysisReport(jobIds: string[] | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Reports/postjobanalysis?";
        if (jobIds !== undefined && jobIds !== null)
            jobIds && jobIds.forEach(item => { url_ += "jobIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostJobAnalysisReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostJobAnalysisReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetPostJobAnalysisReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IShiftSummaryClient {
    getByJobId(jobId: string): Observable<ShiftSummary[]>;
    getById(id: string): Observable<ShiftSummary>;
    update(id: string, shiftSummary: ShiftSummary): Observable<ShiftSummary>;
    delete(id: string): Observable<FileResponse | null>;
    create(shiftSummary: ShiftSummary): Observable<ShiftSummary>;
    submit(id: string): Observable<ShiftSummary>;
    getAttachmentUploadUrl(id: string, fileName: string | null | undefined): Observable<string>;
    getAttachmentDownloadUrl(id: string, attachmentId: string): Observable<string>;
    addAttachment(id: string, attachment: ShiftSummaryAttachment): Observable<ShiftSummary>;
    updateAttachment(id: string, attachmentId: string, attachment: ShiftSummaryAttachment): Observable<ShiftSummary>;
    removeAttachment(id: string, attachmentId: string): Observable<ShiftSummary>;
    getChemicalDosageDownloadUrl(id: string): Observable<string>;
}

@Injectable()
export class ShiftSummaryClient implements IShiftSummaryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getByJobId(jobId: string): Observable<ShiftSummary[]> {
        let url_ = this.baseUrl + "/api/ShiftSummary/byjob/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftSummary[]>;
        }));
    }

    protected processGetByJobId(response: HttpResponseBase): Observable<ShiftSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<ShiftSummary> {
        let url_ = this.baseUrl + "/api/ShiftSummary/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftSummary>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ShiftSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, shiftSummary: ShiftSummary): Observable<ShiftSummary> {
        let url_ = this.baseUrl + "/api/ShiftSummary/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shiftSummary);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftSummary>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ShiftSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ShiftSummary/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(shiftSummary: ShiftSummary): Observable<ShiftSummary> {
        let url_ = this.baseUrl + "/api/ShiftSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shiftSummary);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftSummary>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ShiftSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submit(id: string): Observable<ShiftSummary> {
        let url_ = this.baseUrl + "/api/ShiftSummary/{id}/submit";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftSummary>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<ShiftSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttachmentUploadUrl(id: string, fileName: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ShiftSummary/{id}/attachments/upload-url?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAttachmentUploadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttachmentDownloadUrl(id: string, attachmentId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/ShiftSummary/{id}/attachments/{attachmentId}/download-url";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentDownloadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentDownloadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAttachmentDownloadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addAttachment(id: string, attachment: ShiftSummaryAttachment): Observable<ShiftSummary> {
        let url_ = this.baseUrl + "/api/ShiftSummary/{id}/attachments";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftSummary>;
        }));
    }

    protected processAddAttachment(response: HttpResponseBase): Observable<ShiftSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAttachment(id: string, attachmentId: string, attachment: ShiftSummaryAttachment): Observable<ShiftSummary> {
        let url_ = this.baseUrl + "/api/ShiftSummary/{id}/attachments/{attachmentId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftSummary>;
        }));
    }

    protected processUpdateAttachment(response: HttpResponseBase): Observable<ShiftSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeAttachment(id: string, attachmentId: string): Observable<ShiftSummary> {
        let url_ = this.baseUrl + "/api/ShiftSummary/{id}/attachments/{attachmentId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftSummary>;
        }));
    }

    protected processRemoveAttachment(response: HttpResponseBase): Observable<ShiftSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChemicalDosageDownloadUrl(id: string): Observable<string> {
        let url_ = this.baseUrl + "/api/ShiftSummary/{id}/chemical-dosage/download-url";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChemicalDosageDownloadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChemicalDosageDownloadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetChemicalDosageDownloadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISimulationClient {
    deleteSimulation(id: string): Observable<FileResponse | null>;
    getSimulation(id: string): Observable<Simulation>;
    getSimulationsForCompany(companyId: string): Observable<SimulationHeader[]>;
    saveSimulation(simulation: Simulation): Observable<Simulation>;
}

@Injectable()
export class SimulationClient implements ISimulationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    deleteSimulation(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Simulation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSimulation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSimulation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteSimulation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSimulation(id: string): Observable<Simulation> {
        let url_ = this.baseUrl + "/api/Simulation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSimulation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSimulation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Simulation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Simulation>;
        }));
    }

    protected processGetSimulation(response: HttpResponseBase): Observable<Simulation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Simulation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSimulationsForCompany(companyId: string): Observable<SimulationHeader[]> {
        let url_ = this.baseUrl + "/api/Simulation/byCompany/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSimulationsForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSimulationsForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimulationHeader[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimulationHeader[]>;
        }));
    }

    protected processGetSimulationsForCompany(response: HttpResponseBase): Observable<SimulationHeader[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimulationHeader.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveSimulation(simulation: Simulation): Observable<Simulation> {
        let url_ = this.baseUrl + "/api/Simulation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(simulation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSimulation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSimulation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Simulation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Simulation>;
        }));
    }

    protected processSaveSimulation(response: HttpResponseBase): Observable<Simulation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Simulation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUnitConversionClient {
    get(jobId: string, measurement: string | null | undefined): Observable<UnitConversionInfo[]>;
}

@Injectable()
export class UnitConversionClient implements IUnitConversionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(jobId: string, measurement: string | null | undefined): Observable<UnitConversionInfo[]> {
        let url_ = this.baseUrl + "/api/UnitConversion/{jobId}?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (measurement !== undefined && measurement !== null)
            url_ += "measurement=" + encodeURIComponent("" + measurement) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitConversionInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitConversionInfo[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UnitConversionInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitConversionInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserClient {
    get(): Observable<User[]>;
    post(user: User): Observable<void>;
    getById(id: string): Observable<User>;
    put(id: string, user: User): Observable<void>;
    delete(id: string): Observable<void>;
    getByEmail(userEmail: string | null | undefined): Observable<User>;
    addUserIfNeeded(userEmail: string): Observable<User>;
    getCurrentUser(): Observable<UserInfo>;
    getUserNames(): Observable<UserNameViewModel[]>;
    getUserName(id: string): Observable<UserNameViewModel>;
    getUserNames2(userIds: string | null | undefined): Observable<UserNameViewModel[]>;
    getCompanyUserNames(companyId: string): Observable<UserNameViewModel[]>;
}

@Injectable()
export class UserClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<User[]> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<User[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(user: User): Observable<void> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<User> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(id: string, user: User): Observable<void> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByEmail(userEmail: string | null | undefined): Observable<User> {
        let url_ = this.baseUrl + "/api/User/byEmail?";
        if (userEmail !== undefined && userEmail !== null)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processGetByEmail(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUserIfNeeded(userEmail: string): Observable<User> {
        let url_ = this.baseUrl + "/api/User/addifneeded";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userEmail);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserIfNeeded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserIfNeeded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processAddUserIfNeeded(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentUser(): Observable<UserInfo> {
        let url_ = this.baseUrl + "/api/User/userinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfo>;
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<UserInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserNames(): Observable<UserNameViewModel[]> {
        let url_ = this.baseUrl + "/api/User/names";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNameViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNameViewModel[]>;
        }));
    }

    protected processGetUserNames(response: HttpResponseBase): Observable<UserNameViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserNameViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserName(id: string): Observable<UserNameViewModel> {
        let url_ = this.baseUrl + "/api/User/name/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNameViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNameViewModel>;
        }));
    }

    protected processGetUserName(response: HttpResponseBase): Observable<UserNameViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNameViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserNames2(userIds: string | null | undefined): Observable<UserNameViewModel[]> {
        let url_ = this.baseUrl + "/api/User/specifiednames?";
        if (userIds !== undefined && userIds !== null)
            url_ += "userIds=" + encodeURIComponent("" + userIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNames2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNames2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNameViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNameViewModel[]>;
        }));
    }

    protected processGetUserNames2(response: HttpResponseBase): Observable<UserNameViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserNameViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCompanyUserNames(companyId: string): Observable<UserNameViewModel[]> {
        let url_ = this.baseUrl + "/api/User/companyusers/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyUserNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyUserNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNameViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNameViewModel[]>;
        }));
    }

    protected processGetCompanyUserNames(response: HttpResponseBase): Observable<UserNameViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserNameViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVendorJobClient {
    getVendorJobById(id: string): Observable<VendorJob>;
    put(id: string, job: VendorJob): Observable<void>;
    deleteVendorJob(id: string): Observable<void>;
    getVendorJobByIdFromConsumerJob(id: string): Observable<VendorJob>;
    getVendorJobs(): Observable<VendorJob[]>;
    createVendorJob(vendorJob: VendorJob): Observable<void>;
    getVendorJobsForVendorCompany(companyId: string, newerThan: Date | null | undefined): Observable<VendorJob[]>;
    getVendorJobsForVendorCompanyCount(companyId: string): Observable<number>;
    getDashboardLink(jobId: string): Observable<string>;
    getExport(jobId: string, token: string | null | undefined): Observable<FileResponse | null>;
    getWorkbookExport(jobId: string, token: string | null | undefined): Observable<FileResponse | null>;
    getSummaryExport(jobId: string, token: string | null | undefined): Observable<FileResponse | null>;
    getSummaryExport2(year: number, token: string | null | undefined): Observable<FileResponse | null>;
    isServiceProvider(jobId: string): Observable<boolean>;
    getCompanyIdForJob(jobId: string): Observable<string>;
    doesCompanyHaveData(jobId: string): Observable<boolean>;
    republish(jobId: string): Observable<void>;
}

@Injectable()
export class VendorJobClient implements IVendorJobClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getVendorJobById(id: string): Observable<VendorJob> {
        let url_ = this.baseUrl + "/api/VendorJob/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorJobById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorJobById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorJob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorJob>;
        }));
    }

    protected processGetVendorJobById(response: HttpResponseBase): Observable<VendorJob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VendorJob.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(id: string, job: VendorJob): Observable<void> {
        let url_ = this.baseUrl + "/api/VendorJob/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(job);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVendorJob(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/VendorJob/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVendorJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVendorJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteVendorJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVendorJobByIdFromConsumerJob(id: string): Observable<VendorJob> {
        let url_ = this.baseUrl + "/api/VendorJob/consumer/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorJobByIdFromConsumerJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorJobByIdFromConsumerJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorJob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorJob>;
        }));
    }

    protected processGetVendorJobByIdFromConsumerJob(response: HttpResponseBase): Observable<VendorJob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VendorJob.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVendorJobs(): Observable<VendorJob[]> {
        let url_ = this.baseUrl + "/api/VendorJob";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorJob[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorJob[]>;
        }));
    }

    protected processGetVendorJobs(response: HttpResponseBase): Observable<VendorJob[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorJob.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createVendorJob(vendorJob: VendorJob): Observable<void> {
        let url_ = this.baseUrl + "/api/VendorJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vendorJob);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVendorJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVendorJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateVendorJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVendorJobsForVendorCompany(companyId: string, newerThan: Date | null | undefined): Observable<VendorJob[]> {
        let url_ = this.baseUrl + "/api/VendorJob/company/{companyId}?";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (newerThan !== undefined && newerThan !== null)
            url_ += "newerThan=" + encodeURIComponent(newerThan ? "" + newerThan.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorJobsForVendorCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorJobsForVendorCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorJob[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorJob[]>;
        }));
    }

    protected processGetVendorJobsForVendorCompany(response: HttpResponseBase): Observable<VendorJob[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorJob.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVendorJobsForVendorCompanyCount(companyId: string): Observable<number> {
        let url_ = this.baseUrl + "/api/VendorJob/company/count/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorJobsForVendorCompanyCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorJobsForVendorCompanyCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetVendorJobsForVendorCompanyCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDashboardLink(jobId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/VendorJob/dashboardlink/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDashboardLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExport(jobId: string, token: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/VendorJob/export/{jobId}?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetExport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWorkbookExport(jobId: string, token: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/VendorJob/exportworkbook/{jobId}?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkbookExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkbookExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetWorkbookExport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSummaryExport(jobId: string, token: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/VendorJob/exportsummary/{jobId}?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummaryExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummaryExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetSummaryExport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSummaryExport2(year: number, token: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/VendorJob/exportannualsummary/{year}?";
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummaryExport2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummaryExport2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetSummaryExport2(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isServiceProvider(jobId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/VendorJob/isServiceProvider/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsServiceProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsServiceProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsServiceProvider(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCompanyIdForJob(jobId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/VendorJob/{jobId}/companyId";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyIdForJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyIdForJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCompanyIdForJob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    doesCompanyHaveData(jobId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/VendorJob/hasdata/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoesCompanyHaveData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoesCompanyHaveData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDoesCompanyHaveData(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    republish(jobId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/VendorJob/republish/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRepublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRepublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRepublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IWorkbookConfigurationClient {
    getConfiguration(id: string): Observable<WorkbookConfiguration>;
    put(id: string, config: WorkbookConfiguration): Observable<void>;
    getJobConfiguration(jobNumber: string | null | undefined): Observable<WorkbookConfiguration>;
}

@Injectable()
export class WorkbookConfigurationClient implements IWorkbookConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getConfiguration(id: string): Observable<WorkbookConfiguration> {
        let url_ = this.baseUrl + "/api/WorkbookConfiguration/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbookConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbookConfiguration>;
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<WorkbookConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkbookConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(id: string, config: WorkbookConfiguration): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkbookConfiguration/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getJobConfiguration(jobNumber: string | null | undefined): Observable<WorkbookConfiguration> {
        let url_ = this.baseUrl + "/api/WorkbookConfiguration?";
        if (jobNumber !== undefined && jobNumber !== null)
            url_ += "jobNumber=" + encodeURIComponent("" + jobNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbookConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbookConfiguration>;
        }));
    }

    protected processGetJobConfiguration(response: HttpResponseBase): Observable<WorkbookConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkbookConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IWorkbookClient {
    get(jobId: string): Observable<FileResponse | null>;
    post(workbookLogJson: any): Observable<void>;
    delete(id: string): Observable<void>;
}

@Injectable()
export class WorkbookClient implements IWorkbookClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(jobId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Workbook/GetByJobId/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(workbookLogJson: any): Observable<void> {
        let url_ = this.baseUrl + "/api/Workbook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workbookLogJson);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Workbook/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export abstract class EntityBase implements IEntityBase {
    id?: string | undefined;
    __type?: string | undefined;
    __documentVersion?: string | undefined;
    created!: Date;
    modified!: Date;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;

    constructor(data?: IEntityBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.__type = _data["__type"];
            this.__documentVersion = _data["__documentVersion"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): EntityBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["__type"] = this.__type;
        data["__documentVersion"] = this.__documentVersion;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IEntityBase {
    id?: string | undefined;
    __type?: string | undefined;
    __documentVersion?: string | undefined;
    created: Date;
    modified: Date;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
}

export class CompanyCalculatedFieldConfiguration extends EntityBase implements ICompanyCalculatedFieldConfiguration {
    companyId?: string | undefined;
    calculatedFieldConfigurations?: CalculatedFieldConfiguration[] | undefined;

    constructor(data?: ICompanyCalculatedFieldConfiguration) {
        super(data);
        if (data) {
            if (data.calculatedFieldConfigurations) {
                this.calculatedFieldConfigurations = [];
                for (let i = 0; i < data.calculatedFieldConfigurations.length; i++) {
                    let item = data.calculatedFieldConfigurations[i];
                    this.calculatedFieldConfigurations[i] = item && !(item as any).toJSON ? new CalculatedFieldConfiguration(item) : item as CalculatedFieldConfiguration;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["calculatedFieldConfigurations"])) {
                this.calculatedFieldConfigurations = [] as any;
                for (let item of _data["calculatedFieldConfigurations"])
                    this.calculatedFieldConfigurations!.push(CalculatedFieldConfiguration.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CompanyCalculatedFieldConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyCalculatedFieldConfiguration();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.calculatedFieldConfigurations)) {
            data["calculatedFieldConfigurations"] = [];
            for (let item of this.calculatedFieldConfigurations)
                data["calculatedFieldConfigurations"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICompanyCalculatedFieldConfiguration extends IEntityBase {
    companyId?: string | undefined;
    calculatedFieldConfigurations?: ICalculatedFieldConfiguration[] | undefined;
}

export class CalculatedFieldConfiguration implements ICalculatedFieldConfiguration {
    displayName?: string | undefined;
    fieldName?: string | undefined;
    formula?: string | undefined;

    constructor(data?: ICalculatedFieldConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.fieldName = _data["fieldName"];
            this.formula = _data["formula"];
        }
    }

    static fromJS(data: any): CalculatedFieldConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new CalculatedFieldConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["fieldName"] = this.fieldName;
        data["formula"] = this.formula;
        return data;
    }
}

export interface ICalculatedFieldConfiguration {
    displayName?: string | undefined;
    fieldName?: string | undefined;
    formula?: string | undefined;
}

export class BaseRequest extends EntityBase implements IBaseRequest {
    companyId?: string | undefined;
    requestedById?: string | undefined;
    requestNotes?: string | undefined;
    status?: string | undefined;
    approvedDate!: Date;
    approvedById?: string | undefined;
    rejectedDate!: Date;
    rejectedById?: string | undefined;
    rejectedReason?: string | undefined;

    constructor(data?: IBaseRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.requestedById = _data["requestedById"];
            this.requestNotes = _data["requestNotes"];
            this.status = _data["status"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : undefined as any;
            this.approvedById = _data["approvedById"];
            this.rejectedDate = _data["rejectedDate"] ? new Date(_data["rejectedDate"].toString()) : undefined as any;
            this.rejectedById = _data["rejectedById"];
            this.rejectedReason = _data["rejectedReason"];
        }
    }

    static override fromJS(data: any): BaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BaseRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["requestedById"] = this.requestedById;
        data["requestNotes"] = this.requestNotes;
        data["status"] = this.status;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : undefined as any;
        data["approvedById"] = this.approvedById;
        data["rejectedDate"] = this.rejectedDate ? this.rejectedDate.toISOString() : undefined as any;
        data["rejectedById"] = this.rejectedById;
        data["rejectedReason"] = this.rejectedReason;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseRequest extends IEntityBase {
    companyId?: string | undefined;
    requestedById?: string | undefined;
    requestNotes?: string | undefined;
    status?: string | undefined;
    approvedDate: Date;
    approvedById?: string | undefined;
    rejectedDate: Date;
    rejectedById?: string | undefined;
    rejectedReason?: string | undefined;
}

export class CompanyAssociationRequest extends BaseRequest implements ICompanyAssociationRequest {
    userId?: string | undefined;
    role?: string | undefined;

    constructor(data?: ICompanyAssociationRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.role = _data["role"];
        }
    }

    static override fromJS(data: any): CompanyAssociationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyAssociationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["role"] = this.role;
        super.toJSON(data);
        return data;
    }
}

export interface ICompanyAssociationRequest extends IBaseRequest {
    userId?: string | undefined;
    role?: string | undefined;
}

export class RejectViewModel implements IRejectViewModel {
    reasonMessage?: string | undefined;

    constructor(data?: IRejectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reasonMessage = _data["reasonMessage"];
        }
    }

    static fromJS(data: any): RejectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RejectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonMessage"] = this.reasonMessage;
        return data;
    }
}

export interface IRejectViewModel {
    reasonMessage?: string | undefined;
}

export class Company extends EntityBase implements ICompany {
    name?: string | undefined;
    category?: string | undefined;
    prefix?: string | undefined;
    district?: string | undefined;
    billingAddress?: Address | undefined;
    shippingAddress?: Address | undefined;
    influxDbConnectionInfo?: InfluxDbConnectionInfo | undefined;
    grafanaOrganizationId!: number;
    slackWebhook?: string | undefined;
    serviceProviderIds?: string[] | undefined;
    unitSystem?: string | undefined;
    enableOfflineWorkbook!: boolean;
    sandReportEmailAddresses?: string[] | undefined;
    autoApprovedEmailDomains?: string[] | undefined;
    companyType?: string | undefined;
    isCreatedOrMigratedWithCompanyAdministration?: boolean | undefined;
    apiKey?: string | undefined;

    constructor(data?: ICompany) {
        super(data);
        if (data) {
            this.billingAddress = data.billingAddress && !(data.billingAddress as any).toJSON ? new Address(data.billingAddress) : this.billingAddress as Address;
            this.shippingAddress = data.shippingAddress && !(data.shippingAddress as any).toJSON ? new Address(data.shippingAddress) : this.shippingAddress as Address;
            this.influxDbConnectionInfo = data.influxDbConnectionInfo && !(data.influxDbConnectionInfo as any).toJSON ? new InfluxDbConnectionInfo(data.influxDbConnectionInfo) : this.influxDbConnectionInfo as InfluxDbConnectionInfo;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.category = _data["category"];
            this.prefix = _data["prefix"];
            this.district = _data["district"];
            this.billingAddress = _data["billingAddress"] ? Address.fromJS(_data["billingAddress"]) : undefined as any;
            this.shippingAddress = _data["shippingAddress"] ? Address.fromJS(_data["shippingAddress"]) : undefined as any;
            this.influxDbConnectionInfo = _data["influxDbConnectionInfo"] ? InfluxDbConnectionInfo.fromJS(_data["influxDbConnectionInfo"]) : undefined as any;
            this.grafanaOrganizationId = _data["grafanaOrganizationId"];
            this.slackWebhook = _data["slackWebhook"];
            if (Array.isArray(_data["serviceProviderIds"])) {
                this.serviceProviderIds = [] as any;
                for (let item of _data["serviceProviderIds"])
                    this.serviceProviderIds!.push(item);
            }
            this.unitSystem = _data["unitSystem"];
            this.enableOfflineWorkbook = _data["enableOfflineWorkbook"];
            if (Array.isArray(_data["sandReportEmailAddresses"])) {
                this.sandReportEmailAddresses = [] as any;
                for (let item of _data["sandReportEmailAddresses"])
                    this.sandReportEmailAddresses!.push(item);
            }
            if (Array.isArray(_data["autoApprovedEmailDomains"])) {
                this.autoApprovedEmailDomains = [] as any;
                for (let item of _data["autoApprovedEmailDomains"])
                    this.autoApprovedEmailDomains!.push(item);
            }
            this.companyType = _data["companyType"];
            this.isCreatedOrMigratedWithCompanyAdministration = _data["isCreatedOrMigratedWithCompanyAdministration"];
            this.apiKey = _data["apiKey"];
        }
    }

    static override fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["category"] = this.category;
        data["prefix"] = this.prefix;
        data["district"] = this.district;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : undefined as any;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : undefined as any;
        data["influxDbConnectionInfo"] = this.influxDbConnectionInfo ? this.influxDbConnectionInfo.toJSON() : undefined as any;
        data["grafanaOrganizationId"] = this.grafanaOrganizationId;
        data["slackWebhook"] = this.slackWebhook;
        if (Array.isArray(this.serviceProviderIds)) {
            data["serviceProviderIds"] = [];
            for (let item of this.serviceProviderIds)
                data["serviceProviderIds"].push(item);
        }
        data["unitSystem"] = this.unitSystem;
        data["enableOfflineWorkbook"] = this.enableOfflineWorkbook;
        if (Array.isArray(this.sandReportEmailAddresses)) {
            data["sandReportEmailAddresses"] = [];
            for (let item of this.sandReportEmailAddresses)
                data["sandReportEmailAddresses"].push(item);
        }
        if (Array.isArray(this.autoApprovedEmailDomains)) {
            data["autoApprovedEmailDomains"] = [];
            for (let item of this.autoApprovedEmailDomains)
                data["autoApprovedEmailDomains"].push(item);
        }
        data["companyType"] = this.companyType;
        data["isCreatedOrMigratedWithCompanyAdministration"] = this.isCreatedOrMigratedWithCompanyAdministration;
        data["apiKey"] = this.apiKey;
        super.toJSON(data);
        return data;
    }
}

export interface ICompany extends IEntityBase {
    name?: string | undefined;
    category?: string | undefined;
    prefix?: string | undefined;
    district?: string | undefined;
    billingAddress?: IAddress | undefined;
    shippingAddress?: IAddress | undefined;
    influxDbConnectionInfo?: IInfluxDbConnectionInfo | undefined;
    grafanaOrganizationId: number;
    slackWebhook?: string | undefined;
    serviceProviderIds?: string[] | undefined;
    unitSystem?: string | undefined;
    enableOfflineWorkbook: boolean;
    sandReportEmailAddresses?: string[] | undefined;
    autoApprovedEmailDomains?: string[] | undefined;
    companyType?: string | undefined;
    isCreatedOrMigratedWithCompanyAdministration?: boolean | undefined;
    apiKey?: string | undefined;
}

export class Address implements IAddress {
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        return data;
    }
}

export interface IAddress {
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
}

export class InfluxDbConnectionInfo implements IInfluxDbConnectionInfo {
    url?: string | undefined;
    dbName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IInfluxDbConnectionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.dbName = _data["dbName"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): InfluxDbConnectionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new InfluxDbConnectionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["dbName"] = this.dbName;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IInfluxDbConnectionInfo {
    url?: string | undefined;
    dbName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
}

export class CompanyNameViewModel implements ICompanyNameViewModel {
    companyId?: string | undefined;
    companyName?: string | undefined;
    companyType?: string | undefined;

    constructor(data?: ICompanyNameViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.companyType = _data["companyType"];
        }
    }

    static fromJS(data: any): CompanyNameViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyNameViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["companyType"] = this.companyType;
        return data;
    }
}

export interface ICompanyNameViewModel {
    companyId?: string | undefined;
    companyName?: string | undefined;
    companyType?: string | undefined;
}

export class CompanyContactInfo implements ICompanyContactInfo {
    adminContacts?: CompanyContactInfoPerson[] | undefined;

    constructor(data?: ICompanyContactInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.adminContacts) {
                this.adminContacts = [];
                for (let i = 0; i < data.adminContacts.length; i++) {
                    let item = data.adminContacts[i];
                    this.adminContacts[i] = item && !(item as any).toJSON ? new CompanyContactInfoPerson(item) : item as CompanyContactInfoPerson;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["adminContacts"])) {
                this.adminContacts = [] as any;
                for (let item of _data["adminContacts"])
                    this.adminContacts!.push(CompanyContactInfoPerson.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyContactInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyContactInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.adminContacts)) {
            data["adminContacts"] = [];
            for (let item of this.adminContacts)
                data["adminContacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICompanyContactInfo {
    adminContacts?: ICompanyContactInfoPerson[] | undefined;
}

export class CompanyContactInfoPerson implements ICompanyContactInfoPerson {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;

    constructor(data?: ICompanyContactInfoPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): CompanyContactInfoPerson {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyContactInfoPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface ICompanyContactInfoPerson {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export class WellKnownMeasurementChoice implements IWellKnownMeasurementChoice {
    name?: string | undefined;
    displayName?: string | undefined;
    defaultSiUnit?: UnitChoice | undefined;
    defaultImperialUnit?: UnitChoice | undefined;
    siUnits?: UnitChoice[] | undefined;
    imperialUnits?: UnitChoice[] | undefined;

    constructor(data?: IWellKnownMeasurementChoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.defaultSiUnit = data.defaultSiUnit && !(data.defaultSiUnit as any).toJSON ? new UnitChoice(data.defaultSiUnit) : this.defaultSiUnit as UnitChoice;
            this.defaultImperialUnit = data.defaultImperialUnit && !(data.defaultImperialUnit as any).toJSON ? new UnitChoice(data.defaultImperialUnit) : this.defaultImperialUnit as UnitChoice;
            if (data.siUnits) {
                this.siUnits = [];
                for (let i = 0; i < data.siUnits.length; i++) {
                    let item = data.siUnits[i];
                    this.siUnits[i] = item && !(item as any).toJSON ? new UnitChoice(item) : item as UnitChoice;
                }
            }
            if (data.imperialUnits) {
                this.imperialUnits = [];
                for (let i = 0; i < data.imperialUnits.length; i++) {
                    let item = data.imperialUnits[i];
                    this.imperialUnits[i] = item && !(item as any).toJSON ? new UnitChoice(item) : item as UnitChoice;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.defaultSiUnit = _data["defaultSiUnit"] ? UnitChoice.fromJS(_data["defaultSiUnit"]) : undefined as any;
            this.defaultImperialUnit = _data["defaultImperialUnit"] ? UnitChoice.fromJS(_data["defaultImperialUnit"]) : undefined as any;
            if (Array.isArray(_data["siUnits"])) {
                this.siUnits = [] as any;
                for (let item of _data["siUnits"])
                    this.siUnits!.push(UnitChoice.fromJS(item));
            }
            if (Array.isArray(_data["imperialUnits"])) {
                this.imperialUnits = [] as any;
                for (let item of _data["imperialUnits"])
                    this.imperialUnits!.push(UnitChoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WellKnownMeasurementChoice {
        data = typeof data === 'object' ? data : {};
        let result = new WellKnownMeasurementChoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["defaultSiUnit"] = this.defaultSiUnit ? this.defaultSiUnit.toJSON() : undefined as any;
        data["defaultImperialUnit"] = this.defaultImperialUnit ? this.defaultImperialUnit.toJSON() : undefined as any;
        if (Array.isArray(this.siUnits)) {
            data["siUnits"] = [];
            for (let item of this.siUnits)
                data["siUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imperialUnits)) {
            data["imperialUnits"] = [];
            for (let item of this.imperialUnits)
                data["imperialUnits"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWellKnownMeasurementChoice {
    name?: string | undefined;
    displayName?: string | undefined;
    defaultSiUnit?: IUnitChoice | undefined;
    defaultImperialUnit?: IUnitChoice | undefined;
    siUnits?: IUnitChoice[] | undefined;
    imperialUnits?: IUnitChoice[] | undefined;
}

export class UnitChoice implements IUnitChoice {
    unitName?: string | undefined;
    unitKey?: string | undefined;

    constructor(data?: IUnitChoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitName = _data["unitName"];
            this.unitKey = _data["unitKey"];
        }
    }

    static fromJS(data: any): UnitChoice {
        data = typeof data === 'object' ? data : {};
        let result = new UnitChoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitName"] = this.unitName;
        data["unitKey"] = this.unitKey;
        return data;
    }
}

export interface IUnitChoice {
    unitName?: string | undefined;
    unitKey?: string | undefined;
}

export class CompanyWorkbookConfiguration extends EntityBase implements ICompanyWorkbookConfiguration {
    companyId?: string | undefined;
    workbookMeasurementChannelConfigurations?: WorkbookMeasurementChannelConfiguration[] | undefined;

    constructor(data?: ICompanyWorkbookConfiguration) {
        super(data);
        if (data) {
            if (data.workbookMeasurementChannelConfigurations) {
                this.workbookMeasurementChannelConfigurations = [];
                for (let i = 0; i < data.workbookMeasurementChannelConfigurations.length; i++) {
                    let item = data.workbookMeasurementChannelConfigurations[i];
                    this.workbookMeasurementChannelConfigurations[i] = item && !(item as any).toJSON ? new WorkbookMeasurementChannelConfiguration(item) : item as WorkbookMeasurementChannelConfiguration;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["workbookMeasurementChannelConfigurations"])) {
                this.workbookMeasurementChannelConfigurations = [] as any;
                for (let item of _data["workbookMeasurementChannelConfigurations"])
                    this.workbookMeasurementChannelConfigurations!.push(WorkbookMeasurementChannelConfiguration.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CompanyWorkbookConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyWorkbookConfiguration();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.workbookMeasurementChannelConfigurations)) {
            data["workbookMeasurementChannelConfigurations"] = [];
            for (let item of this.workbookMeasurementChannelConfigurations)
                data["workbookMeasurementChannelConfigurations"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICompanyWorkbookConfiguration extends IEntityBase {
    companyId?: string | undefined;
    workbookMeasurementChannelConfigurations?: IWorkbookMeasurementChannelConfiguration[] | undefined;
}

export class WorkbookMeasurementChannelConfiguration implements IWorkbookMeasurementChannelConfiguration {
    measurementName?: string | undefined;
    measurementDisplayName?: string | undefined;
    unitOfMeasurementId?: string | undefined;
    wellKnownMeasurementName?: string | undefined;
    measurementDataType?: string | undefined;
    activities?: string[] | undefined;
    lookupChoices?: string[] | undefined;
    companyDrivenConfiguration!: boolean;
    readOnlyJobConfiiguration!: boolean;
    jobTypes?: string[] | undefined;
    mininumLimit?: number | undefined;
    maximumLimit?: number | undefined;

    constructor(data?: IWorkbookMeasurementChannelConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementName = _data["measurementName"];
            this.measurementDisplayName = _data["measurementDisplayName"];
            this.unitOfMeasurementId = _data["unitOfMeasurementId"];
            this.wellKnownMeasurementName = _data["wellKnownMeasurementName"];
            this.measurementDataType = _data["measurementDataType"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(item);
            }
            if (Array.isArray(_data["lookupChoices"])) {
                this.lookupChoices = [] as any;
                for (let item of _data["lookupChoices"])
                    this.lookupChoices!.push(item);
            }
            this.companyDrivenConfiguration = _data["companyDrivenConfiguration"];
            this.readOnlyJobConfiiguration = _data["readOnlyJobConfiiguration"];
            if (Array.isArray(_data["jobTypes"])) {
                this.jobTypes = [] as any;
                for (let item of _data["jobTypes"])
                    this.jobTypes!.push(item);
            }
            this.mininumLimit = _data["mininumLimit"];
            this.maximumLimit = _data["maximumLimit"];
        }
    }

    static fromJS(data: any): WorkbookMeasurementChannelConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookMeasurementChannelConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementName"] = this.measurementName;
        data["measurementDisplayName"] = this.measurementDisplayName;
        data["unitOfMeasurementId"] = this.unitOfMeasurementId;
        data["wellKnownMeasurementName"] = this.wellKnownMeasurementName;
        data["measurementDataType"] = this.measurementDataType;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item);
        }
        if (Array.isArray(this.lookupChoices)) {
            data["lookupChoices"] = [];
            for (let item of this.lookupChoices)
                data["lookupChoices"].push(item);
        }
        data["companyDrivenConfiguration"] = this.companyDrivenConfiguration;
        data["readOnlyJobConfiiguration"] = this.readOnlyJobConfiiguration;
        if (Array.isArray(this.jobTypes)) {
            data["jobTypes"] = [];
            for (let item of this.jobTypes)
                data["jobTypes"].push(item);
        }
        data["mininumLimit"] = this.mininumLimit;
        data["maximumLimit"] = this.maximumLimit;
        return data;
    }
}

export interface IWorkbookMeasurementChannelConfiguration {
    measurementName?: string | undefined;
    measurementDisplayName?: string | undefined;
    unitOfMeasurementId?: string | undefined;
    wellKnownMeasurementName?: string | undefined;
    measurementDataType?: string | undefined;
    activities?: string[] | undefined;
    lookupChoices?: string[] | undefined;
    companyDrivenConfiguration: boolean;
    readOnlyJobConfiiguration: boolean;
    jobTypes?: string[] | undefined;
    mininumLimit?: number | undefined;
    maximumLimit?: number | undefined;
}

export class UIConfig implements IUIConfig {
    clientID?: string | undefined;
    tenant?: string | undefined;
    authority?: string | undefined;
    applicationInsightsKey?: string | undefined;
    storageUri?: string | undefined;

    constructor(data?: IUIConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["clientID"];
            this.tenant = _data["tenant"];
            this.authority = _data["authority"];
            this.applicationInsightsKey = _data["applicationInsightsKey"];
            this.storageUri = _data["storageUri"];
        }
    }

    static fromJS(data: any): UIConfig {
        data = typeof data === 'object' ? data : {};
        let result = new UIConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientID"] = this.clientID;
        data["tenant"] = this.tenant;
        data["authority"] = this.authority;
        data["applicationInsightsKey"] = this.applicationInsightsKey;
        data["storageUri"] = this.storageUri;
        return data;
    }
}

export interface IUIConfig {
    clientID?: string | undefined;
    tenant?: string | undefined;
    authority?: string | undefined;
    applicationInsightsKey?: string | undefined;
    storageUri?: string | undefined;
}

export class ConsumerJob extends EntityBase implements IConsumerJob {
    number?: string | undefined;
    consumerCompanyId?: string | undefined;
    wellApiNumber?: string | undefined;
    wellName?: string | undefined;
    startTime!: Date;
    endTime?: Date | undefined;
    workbookType?: string | undefined;
    vendorCompanyIds?: string[] | undefined;
    vendorJobIds?: string[] | undefined;
    jobType!: JobType;
    isMigratedFromBeforeConsumerJobs!: boolean;

    constructor(data?: IConsumerJob) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
            this.consumerCompanyId = _data["consumerCompanyId"];
            this.wellApiNumber = _data["wellApiNumber"];
            this.wellName = _data["wellName"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.workbookType = _data["workbookType"];
            if (Array.isArray(_data["vendorCompanyIds"])) {
                this.vendorCompanyIds = [] as any;
                for (let item of _data["vendorCompanyIds"])
                    this.vendorCompanyIds!.push(item);
            }
            if (Array.isArray(_data["vendorJobIds"])) {
                this.vendorJobIds = [] as any;
                for (let item of _data["vendorJobIds"])
                    this.vendorJobIds!.push(item);
            }
            this.jobType = _data["jobType"];
            this.isMigratedFromBeforeConsumerJobs = _data["isMigratedFromBeforeConsumerJobs"];
        }
    }

    static override fromJS(data: any): ConsumerJob {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerJob();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["consumerCompanyId"] = this.consumerCompanyId;
        data["wellApiNumber"] = this.wellApiNumber;
        data["wellName"] = this.wellName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["workbookType"] = this.workbookType;
        if (Array.isArray(this.vendorCompanyIds)) {
            data["vendorCompanyIds"] = [];
            for (let item of this.vendorCompanyIds)
                data["vendorCompanyIds"].push(item);
        }
        if (Array.isArray(this.vendorJobIds)) {
            data["vendorJobIds"] = [];
            for (let item of this.vendorJobIds)
                data["vendorJobIds"].push(item);
        }
        data["jobType"] = this.jobType;
        data["isMigratedFromBeforeConsumerJobs"] = this.isMigratedFromBeforeConsumerJobs;
        super.toJSON(data);
        return data;
    }
}

export interface IConsumerJob extends IEntityBase {
    number?: string | undefined;
    consumerCompanyId?: string | undefined;
    wellApiNumber?: string | undefined;
    wellName?: string | undefined;
    startTime: Date;
    endTime?: Date | undefined;
    workbookType?: string | undefined;
    vendorCompanyIds?: string[] | undefined;
    vendorJobIds?: string[] | undefined;
    jobType: JobType;
    isMigratedFromBeforeConsumerJobs: boolean;
}

export enum JobType {
    BeforeOfflineWorkbook = 0,
    OfflineWorkbook = 1,
    OfflineFlowbackWorkbook = 2,
    VendorJob = 3,
    ConsumerJob = 4,
    VendorFlowbackJob = 5,
    ConsumerFlowbackJob = 6,
}

export class Device extends EntityBase implements IDevice {
    name?: string | undefined;
    category?: string | undefined;
    companyId?: string | undefined;
    measurementChannelConfigurations?: DeviceMeasurementChannelConfiguration[] | undefined;
    isDeleted?: boolean | undefined;
    tcpDeviceConfiguration?: TcpDeviceConfiguration | undefined;

    constructor(data?: IDevice) {
        super(data);
        if (data) {
            if (data.measurementChannelConfigurations) {
                this.measurementChannelConfigurations = [];
                for (let i = 0; i < data.measurementChannelConfigurations.length; i++) {
                    let item = data.measurementChannelConfigurations[i];
                    this.measurementChannelConfigurations[i] = item && !(item as any).toJSON ? new DeviceMeasurementChannelConfiguration(item) : item as DeviceMeasurementChannelConfiguration;
                }
            }
            this.tcpDeviceConfiguration = data.tcpDeviceConfiguration && !(data.tcpDeviceConfiguration as any).toJSON ? new TcpDeviceConfiguration(data.tcpDeviceConfiguration) : this.tcpDeviceConfiguration as TcpDeviceConfiguration;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.category = _data["category"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["measurementChannelConfigurations"])) {
                this.measurementChannelConfigurations = [] as any;
                for (let item of _data["measurementChannelConfigurations"])
                    this.measurementChannelConfigurations!.push(DeviceMeasurementChannelConfiguration.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.tcpDeviceConfiguration = _data["tcpDeviceConfiguration"] ? TcpDeviceConfiguration.fromJS(_data["tcpDeviceConfiguration"]) : undefined as any;
        }
    }

    static override fromJS(data: any): Device {
        data = typeof data === 'object' ? data : {};
        let result = new Device();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["category"] = this.category;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.measurementChannelConfigurations)) {
            data["measurementChannelConfigurations"] = [];
            for (let item of this.measurementChannelConfigurations)
                data["measurementChannelConfigurations"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeleted"] = this.isDeleted;
        data["tcpDeviceConfiguration"] = this.tcpDeviceConfiguration ? this.tcpDeviceConfiguration.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDevice extends IEntityBase {
    name?: string | undefined;
    category?: string | undefined;
    companyId?: string | undefined;
    measurementChannelConfigurations?: IDeviceMeasurementChannelConfiguration[] | undefined;
    isDeleted?: boolean | undefined;
    tcpDeviceConfiguration?: ITcpDeviceConfiguration | undefined;
}

export class DeviceMeasurementChannelConfiguration implements IDeviceMeasurementChannelConfiguration {
    measurementName?: string | undefined;
    measurementDisplayName?: string | undefined;
    unitOfMeasurementId?: string | undefined;
    wellKnownMeasurementName?: string | undefined;
    measurementDataType?: string | undefined;

    constructor(data?: IDeviceMeasurementChannelConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementName = _data["measurementName"];
            this.measurementDisplayName = _data["measurementDisplayName"];
            this.unitOfMeasurementId = _data["unitOfMeasurementId"];
            this.wellKnownMeasurementName = _data["wellKnownMeasurementName"];
            this.measurementDataType = _data["measurementDataType"];
        }
    }

    static fromJS(data: any): DeviceMeasurementChannelConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceMeasurementChannelConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementName"] = this.measurementName;
        data["measurementDisplayName"] = this.measurementDisplayName;
        data["unitOfMeasurementId"] = this.unitOfMeasurementId;
        data["wellKnownMeasurementName"] = this.wellKnownMeasurementName;
        data["measurementDataType"] = this.measurementDataType;
        return data;
    }
}

export interface IDeviceMeasurementChannelConfiguration {
    measurementName?: string | undefined;
    measurementDisplayName?: string | undefined;
    unitOfMeasurementId?: string | undefined;
    wellKnownMeasurementName?: string | undefined;
    measurementDataType?: string | undefined;
}

export class TcpDeviceConfiguration implements ITcpDeviceConfiguration {
    hostPort?: string | undefined;
    active!: boolean;
    lastMessage?: string | undefined;

    constructor(data?: ITcpDeviceConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hostPort = _data["hostPort"];
            this.active = _data["active"];
            this.lastMessage = _data["lastMessage"];
        }
    }

    static fromJS(data: any): TcpDeviceConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new TcpDeviceConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hostPort"] = this.hostPort;
        data["active"] = this.active;
        data["lastMessage"] = this.lastMessage;
        return data;
    }
}

export interface ITcpDeviceConfiguration {
    hostPort?: string | undefined;
    active: boolean;
    lastMessage?: string | undefined;
}

export class DeviceJobMapping implements IDeviceJobMapping {
    deviceId!: string;
    deviceName!: string;
    deviceType!: string;
    companyId!: string;
    jobId?: string | undefined;
    jobName?: string | undefined;
    jobStartDate?: Date | undefined;
    jobEndDate?: Date | undefined;

    constructor(data?: IDeviceJobMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.deviceName = _data["deviceName"];
            this.deviceType = _data["deviceType"];
            this.companyId = _data["companyId"];
            this.jobId = _data["jobId"];
            this.jobName = _data["jobName"];
            this.jobStartDate = _data["jobStartDate"] ? new Date(_data["jobStartDate"].toString()) : undefined as any;
            this.jobEndDate = _data["jobEndDate"] ? new Date(_data["jobEndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DeviceJobMapping {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceJobMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["deviceType"] = this.deviceType;
        data["companyId"] = this.companyId;
        data["jobId"] = this.jobId;
        data["jobName"] = this.jobName;
        data["jobStartDate"] = this.jobStartDate ? this.jobStartDate.toISOString() : undefined as any;
        data["jobEndDate"] = this.jobEndDate ? this.jobEndDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IDeviceJobMapping {
    deviceId: string;
    deviceName: string;
    deviceType: string;
    companyId: string;
    jobId?: string | undefined;
    jobName?: string | undefined;
    jobStartDate?: Date | undefined;
    jobEndDate?: Date | undefined;
}

export class DeviceDiagnosticViewModel implements IDeviceDiagnosticViewModel {
    deviceId?: string | undefined;
    deviceName?: string | undefined;
    companyId?: string | undefined;
    mostRecentUtcTimestamp?: Date | undefined;
    measurements?: DeviceDiagnosticMeasurement[] | undefined;

    constructor(data?: IDeviceDiagnosticViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.measurements) {
                this.measurements = [];
                for (let i = 0; i < data.measurements.length; i++) {
                    let item = data.measurements[i];
                    this.measurements[i] = item && !(item as any).toJSON ? new DeviceDiagnosticMeasurement(item) : item as DeviceDiagnosticMeasurement;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.deviceName = _data["deviceName"];
            this.companyId = _data["companyId"];
            this.mostRecentUtcTimestamp = _data["mostRecentUtcTimestamp"] ? new Date(_data["mostRecentUtcTimestamp"].toString()) : undefined as any;
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [] as any;
                for (let item of _data["measurements"])
                    this.measurements!.push(DeviceDiagnosticMeasurement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceDiagnosticViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDiagnosticViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["companyId"] = this.companyId;
        data["mostRecentUtcTimestamp"] = this.mostRecentUtcTimestamp ? this.mostRecentUtcTimestamp.toISOString() : undefined as any;
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDeviceDiagnosticViewModel {
    deviceId?: string | undefined;
    deviceName?: string | undefined;
    companyId?: string | undefined;
    mostRecentUtcTimestamp?: Date | undefined;
    measurements?: IDeviceDiagnosticMeasurement[] | undefined;
}

export class DeviceDiagnosticMeasurement implements IDeviceDiagnosticMeasurement {
    measurementName?: string | undefined;
    utcTimestamp!: Date;
    value?: any | undefined;
    fields?: { [key: string]: any; } | undefined;
    tags?: { [key: string]: string; } | undefined;

    constructor(data?: IDeviceDiagnosticMeasurement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementName = _data["measurementName"];
            this.utcTimestamp = _data["utcTimestamp"] ? new Date(_data["utcTimestamp"].toString()) : undefined as any;
            this.value = _data["value"];
            if (_data["fields"]) {
                this.fields = {} as any;
                for (let key in _data["fields"]) {
                    if (_data["fields"].hasOwnProperty(key))
                        (this.fields as any)![key] = _data["fields"][key];
                }
            }
            if (_data["tags"]) {
                this.tags = {} as any;
                for (let key in _data["tags"]) {
                    if (_data["tags"].hasOwnProperty(key))
                        (this.tags as any)![key] = _data["tags"][key];
                }
            }
        }
    }

    static fromJS(data: any): DeviceDiagnosticMeasurement {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDiagnosticMeasurement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementName"] = this.measurementName;
        data["utcTimestamp"] = this.utcTimestamp ? this.utcTimestamp.toISOString() : undefined as any;
        data["value"] = this.value;
        if (this.fields) {
            data["fields"] = {};
            for (let key in this.fields) {
                if (this.fields.hasOwnProperty(key))
                    (data["fields"] as any)[key] = (this.fields as any)[key];
            }
        }
        if (this.tags) {
            data["tags"] = {};
            for (let key in this.tags) {
                if (this.tags.hasOwnProperty(key))
                    (data["tags"] as any)[key] = (this.tags as any)[key];
            }
        }
        return data;
    }
}

export interface IDeviceDiagnosticMeasurement {
    measurementName?: string | undefined;
    utcTimestamp: Date;
    value?: any | undefined;
    fields?: { [key: string]: any; } | undefined;
    tags?: { [key: string]: string; } | undefined;
}

export class FileSasTokenResult implements IFileSasTokenResult {
    container?: string | undefined;
    blob?: string | undefined;
    expiresOnUtc!: Date;
    sasToken?: string | undefined;
    url?: string | undefined;

    constructor(data?: IFileSasTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.container = _data["container"];
            this.blob = _data["blob"];
            this.expiresOnUtc = _data["expiresOnUtc"] ? new Date(_data["expiresOnUtc"].toString()) : undefined as any;
            this.sasToken = _data["sasToken"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): FileSasTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new FileSasTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["container"] = this.container;
        data["blob"] = this.blob;
        data["expiresOnUtc"] = this.expiresOnUtc ? this.expiresOnUtc.toISOString() : undefined as any;
        data["sasToken"] = this.sasToken;
        data["url"] = this.url;
        return data;
    }
}

export interface IFileSasTokenResult {
    container?: string | undefined;
    blob?: string | undefined;
    expiresOnUtc: Date;
    sasToken?: string | undefined;
    url?: string | undefined;
}

export class FilesListResult implements IFilesListResult {
    container?: string | undefined;
    directory?: string | undefined;
    count!: number;
    items?: FileItem[] | undefined;

    constructor(data?: IFilesListResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(item as any).toJSON ? new FileItem(item) : item as FileItem;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.container = _data["container"];
            this.directory = _data["directory"];
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FileItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilesListResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilesListResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["container"] = this.container;
        data["directory"] = this.directory;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilesListResult {
    container?: string | undefined;
    directory?: string | undefined;
    count: number;
    items?: IFileItem[] | undefined;
}

export class FileItem implements IFileItem {
    name?: string | undefined;
    size!: number;
    lastModifiedUtc?: Date | undefined;
    contentType?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    sasToken?: string | undefined;
    url?: string | undefined;
    expiresOnUtc?: Date | undefined;

    constructor(data?: IFileItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.size = _data["size"];
            this.lastModifiedUtc = _data["lastModifiedUtc"] ? new Date(_data["lastModifiedUtc"].toString()) : undefined as any;
            this.contentType = _data["contentType"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (this.metadata as any)![key] = _data["metadata"][key];
                }
            }
            this.sasToken = _data["sasToken"];
            this.url = _data["url"];
            this.expiresOnUtc = _data["expiresOnUtc"] ? new Date(_data["expiresOnUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FileItem {
        data = typeof data === 'object' ? data : {};
        let result = new FileItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["size"] = this.size;
        data["lastModifiedUtc"] = this.lastModifiedUtc ? this.lastModifiedUtc.toISOString() : undefined as any;
        data["contentType"] = this.contentType;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (data["metadata"] as any)[key] = (this.metadata as any)[key];
            }
        }
        data["sasToken"] = this.sasToken;
        data["url"] = this.url;
        data["expiresOnUtc"] = this.expiresOnUtc ? this.expiresOnUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IFileItem {
    name?: string | undefined;
    size: number;
    lastModifiedUtc?: Date | undefined;
    contentType?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    sasToken?: string | undefined;
    url?: string | undefined;
    expiresOnUtc?: Date | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class CsvJobImport extends EntityBase implements ICsvJobImport {
    name?: string | undefined;
    deviceId?: string | undefined;
    jobId?: string | undefined;
    timeOffset?: number | undefined;

    constructor(data?: ICsvJobImport) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.deviceId = _data["deviceId"];
            this.jobId = _data["jobId"];
            this.timeOffset = _data["timeOffset"];
        }
    }

    static override fromJS(data: any): CsvJobImport {
        data = typeof data === 'object' ? data : {};
        let result = new CsvJobImport();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["deviceId"] = this.deviceId;
        data["jobId"] = this.jobId;
        data["timeOffset"] = this.timeOffset;
        super.toJSON(data);
        return data;
    }
}

export interface ICsvJobImport extends IEntityBase {
    name?: string | undefined;
    deviceId?: string | undefined;
    jobId?: string | undefined;
    timeOffset?: number | undefined;
}

export class IncomingMeasurment implements IIncomingMeasurment {
    timestamp!: Date;
    measurement?: string | undefined;
    value!: number;
    deviceId?: string | undefined;

    constructor(data?: IIncomingMeasurment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            this.measurement = _data["measurement"];
            this.value = _data["value"];
            this.deviceId = _data["deviceId"];
        }
    }

    static fromJS(data: any): IncomingMeasurment {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMeasurment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        data["measurement"] = this.measurement;
        data["value"] = this.value;
        data["deviceId"] = this.deviceId;
        return data;
    }
}

export interface IIncomingMeasurment {
    timestamp: Date;
    measurement?: string | undefined;
    value: number;
    deviceId?: string | undefined;
}

export class JobIntegration extends EntityBase implements IJobIntegration {
    jobId?: string | undefined;
    jobName?: string | undefined;
    jobStartDate?: Date | undefined;
    jobEndDate?: Date | undefined;
    integrationCompany?: string | undefined;
    integrationType?: string | undefined;
    status?: string | undefined;
    configuration?: string | undefined;
    companyId?: string | undefined;
    companyName?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IJobIntegration) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobId = _data["jobId"];
            this.jobName = _data["jobName"];
            this.jobStartDate = _data["jobStartDate"] ? new Date(_data["jobStartDate"].toString()) : undefined as any;
            this.jobEndDate = _data["jobEndDate"] ? new Date(_data["jobEndDate"].toString()) : undefined as any;
            this.integrationCompany = _data["integrationCompany"];
            this.integrationType = _data["integrationType"];
            this.status = _data["status"];
            this.configuration = _data["configuration"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.notes = _data["notes"];
        }
    }

    static override fromJS(data: any): JobIntegration {
        data = typeof data === 'object' ? data : {};
        let result = new JobIntegration();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["jobName"] = this.jobName;
        data["jobStartDate"] = this.jobStartDate ? this.jobStartDate.toISOString() : undefined as any;
        data["jobEndDate"] = this.jobEndDate ? this.jobEndDate.toISOString() : undefined as any;
        data["integrationCompany"] = this.integrationCompany;
        data["integrationType"] = this.integrationType;
        data["status"] = this.status;
        data["configuration"] = this.configuration;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["notes"] = this.notes;
        super.toJSON(data);
        return data;
    }
}

export interface IJobIntegration extends IEntityBase {
    jobId?: string | undefined;
    jobName?: string | undefined;
    jobStartDate?: Date | undefined;
    jobEndDate?: Date | undefined;
    integrationCompany?: string | undefined;
    integrationType?: string | undefined;
    status?: string | undefined;
    configuration?: string | undefined;
    companyId?: string | undefined;
    companyName?: string | undefined;
    notes?: string | undefined;
}

export class Job extends EntityBase implements IJob {
    name?: string | undefined;
    companyId?: string | undefined;
    deviceList?: string[] | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    apiNumber?: string | undefined;
    district?: string | undefined;
    field?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    specialInstructions?: string | undefined;
    wellSiteDirections?: string | undefined;
    section?: string | undefined;
    township?: string | undefined;
    range?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    operator?: string | undefined;
    essFrcsUnit?: string | undefined;
    chemicalProvider?: string | undefined;
    frcsDayEngineer?: string | undefined;
    frcsNightEngineer?: string | undefined;
    dayOperators?: string[] | undefined;
    nightOperators?: string[] | undefined;
    osrDay?: string | undefined;
    osrNight?: string | undefined;
    fieldEngineer1Name?: string | undefined;
    fieldEngineer1Phone?: string | undefined;
    fieldEngineer1Email?: string | undefined;
    fieldEngineer2Name?: string | undefined;
    fieldEngineer2Phone?: string | undefined;
    fieldEngineer2Email?: string | undefined;
    ctWorWlProvider?: string | undefined;
    flowbackProvider?: string | undefined;
    dhToolProvider?: string | undefined;
    procedureDesc?: string | undefined;
    tubingUnitDesc?: string | undefined;
    mill?: string | undefined;
    plugType?: string | undefined;
    status?: string | undefined;
    upstreamSandSeparatorType?: string | undefined;
    downstreamSandSeparatorType?: string | undefined;
    emailDailyReportsTo?: string | undefined;
    millType?: string | undefined;
    millOd?: string | undefined;
    bhaOd?: string | undefined;
    ertType?: string | undefined;
    wellInfo?: WellInfo | undefined;
    fluidInfo?: FluidInfo | undefined;
    performanceSummary?: PerformanceSummary | undefined;
    fluidSummary?: FluidSummary | undefined;
    serviceProviderIds?: string[] | undefined;
    enableOfflineWorkbook!: boolean;
    workbookType?: string | undefined;
    jobType!: JobType;
    isMigrated!: boolean;
    useOldWorkbookInReadOnlyMode!: boolean;

    constructor(data?: IJob) {
        super(data);
        if (data) {
            this.wellInfo = data.wellInfo && !(data.wellInfo as any).toJSON ? new WellInfo(data.wellInfo) : this.wellInfo as WellInfo;
            this.fluidInfo = data.fluidInfo && !(data.fluidInfo as any).toJSON ? new FluidInfo(data.fluidInfo) : this.fluidInfo as FluidInfo;
            this.performanceSummary = data.performanceSummary && !(data.performanceSummary as any).toJSON ? new PerformanceSummary(data.performanceSummary) : this.performanceSummary as PerformanceSummary;
            this.fluidSummary = data.fluidSummary && !(data.fluidSummary as any).toJSON ? new FluidSummary(data.fluidSummary) : this.fluidSummary as FluidSummary;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["deviceList"])) {
                this.deviceList = [] as any;
                for (let item of _data["deviceList"])
                    this.deviceList!.push(item);
            }
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.apiNumber = _data["apiNumber"];
            this.district = _data["district"];
            this.field = _data["field"];
            this.state = _data["state"];
            this.county = _data["county"];
            this.specialInstructions = _data["specialInstructions"];
            this.wellSiteDirections = _data["wellSiteDirections"];
            this.section = _data["section"];
            this.township = _data["township"];
            this.range = _data["range"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.operator = _data["operator"];
            this.essFrcsUnit = _data["essFrcsUnit"];
            this.chemicalProvider = _data["chemicalProvider"];
            this.frcsDayEngineer = _data["frcsDayEngineer"];
            this.frcsNightEngineer = _data["frcsNightEngineer"];
            if (Array.isArray(_data["dayOperators"])) {
                this.dayOperators = [] as any;
                for (let item of _data["dayOperators"])
                    this.dayOperators!.push(item);
            }
            if (Array.isArray(_data["nightOperators"])) {
                this.nightOperators = [] as any;
                for (let item of _data["nightOperators"])
                    this.nightOperators!.push(item);
            }
            this.osrDay = _data["osrDay"];
            this.osrNight = _data["osrNight"];
            this.fieldEngineer1Name = _data["fieldEngineer1Name"];
            this.fieldEngineer1Phone = _data["fieldEngineer1Phone"];
            this.fieldEngineer1Email = _data["fieldEngineer1Email"];
            this.fieldEngineer2Name = _data["fieldEngineer2Name"];
            this.fieldEngineer2Phone = _data["fieldEngineer2Phone"];
            this.fieldEngineer2Email = _data["fieldEngineer2Email"];
            this.ctWorWlProvider = _data["ctWorWlProvider"];
            this.flowbackProvider = _data["flowbackProvider"];
            this.dhToolProvider = _data["dhToolProvider"];
            this.procedureDesc = _data["procedureDesc"];
            this.tubingUnitDesc = _data["tubingUnitDesc"];
            this.mill = _data["mill"];
            this.plugType = _data["plugType"];
            this.status = _data["status"];
            this.upstreamSandSeparatorType = _data["upstreamSandSeparatorType"];
            this.downstreamSandSeparatorType = _data["downstreamSandSeparatorType"];
            this.emailDailyReportsTo = _data["emailDailyReportsTo"];
            this.millType = _data["millType"];
            this.millOd = _data["millOd"];
            this.bhaOd = _data["bhaOd"];
            this.ertType = _data["ertType"];
            this.wellInfo = _data["wellInfo"] ? WellInfo.fromJS(_data["wellInfo"]) : undefined as any;
            this.fluidInfo = _data["fluidInfo"] ? FluidInfo.fromJS(_data["fluidInfo"]) : undefined as any;
            this.performanceSummary = _data["performanceSummary"] ? PerformanceSummary.fromJS(_data["performanceSummary"]) : undefined as any;
            this.fluidSummary = _data["fluidSummary"] ? FluidSummary.fromJS(_data["fluidSummary"]) : undefined as any;
            if (Array.isArray(_data["serviceProviderIds"])) {
                this.serviceProviderIds = [] as any;
                for (let item of _data["serviceProviderIds"])
                    this.serviceProviderIds!.push(item);
            }
            this.enableOfflineWorkbook = _data["enableOfflineWorkbook"];
            this.workbookType = _data["workbookType"];
            this.jobType = _data["jobType"];
            this.isMigrated = _data["isMigrated"];
            this.useOldWorkbookInReadOnlyMode = _data["useOldWorkbookInReadOnlyMode"];
        }
    }

    static override fromJS(data: any): Job {
        data = typeof data === 'object' ? data : {};
        let result = new Job();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.deviceList)) {
            data["deviceList"] = [];
            for (let item of this.deviceList)
                data["deviceList"].push(item);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["apiNumber"] = this.apiNumber;
        data["district"] = this.district;
        data["field"] = this.field;
        data["state"] = this.state;
        data["county"] = this.county;
        data["specialInstructions"] = this.specialInstructions;
        data["wellSiteDirections"] = this.wellSiteDirections;
        data["section"] = this.section;
        data["township"] = this.township;
        data["range"] = this.range;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["operator"] = this.operator;
        data["essFrcsUnit"] = this.essFrcsUnit;
        data["chemicalProvider"] = this.chemicalProvider;
        data["frcsDayEngineer"] = this.frcsDayEngineer;
        data["frcsNightEngineer"] = this.frcsNightEngineer;
        if (Array.isArray(this.dayOperators)) {
            data["dayOperators"] = [];
            for (let item of this.dayOperators)
                data["dayOperators"].push(item);
        }
        if (Array.isArray(this.nightOperators)) {
            data["nightOperators"] = [];
            for (let item of this.nightOperators)
                data["nightOperators"].push(item);
        }
        data["osrDay"] = this.osrDay;
        data["osrNight"] = this.osrNight;
        data["fieldEngineer1Name"] = this.fieldEngineer1Name;
        data["fieldEngineer1Phone"] = this.fieldEngineer1Phone;
        data["fieldEngineer1Email"] = this.fieldEngineer1Email;
        data["fieldEngineer2Name"] = this.fieldEngineer2Name;
        data["fieldEngineer2Phone"] = this.fieldEngineer2Phone;
        data["fieldEngineer2Email"] = this.fieldEngineer2Email;
        data["ctWorWlProvider"] = this.ctWorWlProvider;
        data["flowbackProvider"] = this.flowbackProvider;
        data["dhToolProvider"] = this.dhToolProvider;
        data["procedureDesc"] = this.procedureDesc;
        data["tubingUnitDesc"] = this.tubingUnitDesc;
        data["mill"] = this.mill;
        data["plugType"] = this.plugType;
        data["status"] = this.status;
        data["upstreamSandSeparatorType"] = this.upstreamSandSeparatorType;
        data["downstreamSandSeparatorType"] = this.downstreamSandSeparatorType;
        data["emailDailyReportsTo"] = this.emailDailyReportsTo;
        data["millType"] = this.millType;
        data["millOd"] = this.millOd;
        data["bhaOd"] = this.bhaOd;
        data["ertType"] = this.ertType;
        data["wellInfo"] = this.wellInfo ? this.wellInfo.toJSON() : undefined as any;
        data["fluidInfo"] = this.fluidInfo ? this.fluidInfo.toJSON() : undefined as any;
        data["performanceSummary"] = this.performanceSummary ? this.performanceSummary.toJSON() : undefined as any;
        data["fluidSummary"] = this.fluidSummary ? this.fluidSummary.toJSON() : undefined as any;
        if (Array.isArray(this.serviceProviderIds)) {
            data["serviceProviderIds"] = [];
            for (let item of this.serviceProviderIds)
                data["serviceProviderIds"].push(item);
        }
        data["enableOfflineWorkbook"] = this.enableOfflineWorkbook;
        data["workbookType"] = this.workbookType;
        data["jobType"] = this.jobType;
        data["isMigrated"] = this.isMigrated;
        data["useOldWorkbookInReadOnlyMode"] = this.useOldWorkbookInReadOnlyMode;
        super.toJSON(data);
        return data;
    }
}

export interface IJob extends IEntityBase {
    name?: string | undefined;
    companyId?: string | undefined;
    deviceList?: string[] | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    apiNumber?: string | undefined;
    district?: string | undefined;
    field?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    specialInstructions?: string | undefined;
    wellSiteDirections?: string | undefined;
    section?: string | undefined;
    township?: string | undefined;
    range?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    operator?: string | undefined;
    essFrcsUnit?: string | undefined;
    chemicalProvider?: string | undefined;
    frcsDayEngineer?: string | undefined;
    frcsNightEngineer?: string | undefined;
    dayOperators?: string[] | undefined;
    nightOperators?: string[] | undefined;
    osrDay?: string | undefined;
    osrNight?: string | undefined;
    fieldEngineer1Name?: string | undefined;
    fieldEngineer1Phone?: string | undefined;
    fieldEngineer1Email?: string | undefined;
    fieldEngineer2Name?: string | undefined;
    fieldEngineer2Phone?: string | undefined;
    fieldEngineer2Email?: string | undefined;
    ctWorWlProvider?: string | undefined;
    flowbackProvider?: string | undefined;
    dhToolProvider?: string | undefined;
    procedureDesc?: string | undefined;
    tubingUnitDesc?: string | undefined;
    mill?: string | undefined;
    plugType?: string | undefined;
    status?: string | undefined;
    upstreamSandSeparatorType?: string | undefined;
    downstreamSandSeparatorType?: string | undefined;
    emailDailyReportsTo?: string | undefined;
    millType?: string | undefined;
    millOd?: string | undefined;
    bhaOd?: string | undefined;
    ertType?: string | undefined;
    wellInfo?: IWellInfo | undefined;
    fluidInfo?: IFluidInfo | undefined;
    performanceSummary?: IPerformanceSummary | undefined;
    fluidSummary?: IFluidSummary | undefined;
    serviceProviderIds?: string[] | undefined;
    enableOfflineWorkbook: boolean;
    workbookType?: string | undefined;
    jobType: JobType;
    isMigrated: boolean;
    useOldWorkbookInReadOnlyMode: boolean;
}

export class VendorJob extends Job implements IVendorJob {
    consumerCompanyId?: string | undefined;
    consumerJobId?: string | undefined;
    enableOfflineWorkbook!: boolean;
    jobType!: JobType;

    constructor(data?: IVendorJob) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.consumerCompanyId = _data["consumerCompanyId"];
            this.consumerJobId = _data["consumerJobId"];
            this.enableOfflineWorkbook = _data["enableOfflineWorkbook"];
            this.jobType = _data["jobType"];
        }
    }

    static override fromJS(data: any): VendorJob {
        data = typeof data === 'object' ? data : {};
        let result = new VendorJob();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerCompanyId"] = this.consumerCompanyId;
        data["consumerJobId"] = this.consumerJobId;
        data["enableOfflineWorkbook"] = this.enableOfflineWorkbook;
        data["jobType"] = this.jobType;
        super.toJSON(data);
        return data;
    }
}

export interface IVendorJob extends IJob {
    consumerCompanyId?: string | undefined;
    consumerJobId?: string | undefined;
    enableOfflineWorkbook: boolean;
    jobType: JobType;
}

export class WellInfo implements IWellInfo {
    name?: string | undefined;
    wellType?: string | undefined;
    xoEot?: number | undefined;
    kop?: number | undefined;
    thirtyDegree?: number | undefined;
    sixtyDegree?: number | undefined;
    tvd?: number | undefined;
    md?: number | undefined;
    coilCapacity?: number | undefined;
    stringType?: string | undefined;
    ctWoTubingOd?: number | undefined;
    hozTubingOd?: number | undefined;
    ctWoTubingOdId?: number | undefined;
    hozTubingOdId?: number | undefined;
    csgId?: number | undefined;
    lateralLengthEst?: number | undefined;
    casings?: Casing[] | undefined;
    casingTubings?: CasingTubings | undefined;
    plugs?: Plug[] | undefined;
    plugSets?: PlugSet[] | undefined;
    fracPlugStages?: number | undefined;
    sitp?: number | undefined;
    sicp?: number | undefined;

    constructor(data?: IWellInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.casings) {
                this.casings = [];
                for (let i = 0; i < data.casings.length; i++) {
                    let item = data.casings[i];
                    this.casings[i] = item && !(item as any).toJSON ? new Casing(item) : item as Casing;
                }
            }
            this.casingTubings = data.casingTubings && !(data.casingTubings as any).toJSON ? new CasingTubings(data.casingTubings) : this.casingTubings as CasingTubings;
            if (data.plugs) {
                this.plugs = [];
                for (let i = 0; i < data.plugs.length; i++) {
                    let item = data.plugs[i];
                    this.plugs[i] = item && !(item as any).toJSON ? new Plug(item) : item as Plug;
                }
            }
            if (data.plugSets) {
                this.plugSets = [];
                for (let i = 0; i < data.plugSets.length; i++) {
                    let item = data.plugSets[i];
                    this.plugSets[i] = item && !(item as any).toJSON ? new PlugSet(item) : item as PlugSet;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.wellType = _data["wellType"];
            this.xoEot = _data["xoEot"];
            this.kop = _data["kop"];
            this.thirtyDegree = _data["thirtyDegree"];
            this.sixtyDegree = _data["sixtyDegree"];
            this.tvd = _data["tvd"];
            this.md = _data["md"];
            this.coilCapacity = _data["coilCapacity"];
            this.stringType = _data["stringType"];
            this.ctWoTubingOd = _data["ctWoTubingOd"];
            this.hozTubingOd = _data["hozTubingOd"];
            this.ctWoTubingOdId = _data["ctWoTubingOdId"];
            this.hozTubingOdId = _data["hozTubingOdId"];
            this.csgId = _data["csgId"];
            this.lateralLengthEst = _data["lateralLengthEst"];
            if (Array.isArray(_data["casings"])) {
                this.casings = [] as any;
                for (let item of _data["casings"])
                    this.casings!.push(Casing.fromJS(item));
            }
            this.casingTubings = _data["casingTubings"] ? CasingTubings.fromJS(_data["casingTubings"]) : undefined as any;
            if (Array.isArray(_data["plugs"])) {
                this.plugs = [] as any;
                for (let item of _data["plugs"])
                    this.plugs!.push(Plug.fromJS(item));
            }
            if (Array.isArray(_data["plugSets"])) {
                this.plugSets = [] as any;
                for (let item of _data["plugSets"])
                    this.plugSets!.push(PlugSet.fromJS(item));
            }
            this.fracPlugStages = _data["fracPlugStages"];
            this.sitp = _data["sitp"];
            this.sicp = _data["sicp"];
        }
    }

    static fromJS(data: any): WellInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WellInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["wellType"] = this.wellType;
        data["xoEot"] = this.xoEot;
        data["kop"] = this.kop;
        data["thirtyDegree"] = this.thirtyDegree;
        data["sixtyDegree"] = this.sixtyDegree;
        data["tvd"] = this.tvd;
        data["md"] = this.md;
        data["coilCapacity"] = this.coilCapacity;
        data["stringType"] = this.stringType;
        data["ctWoTubingOd"] = this.ctWoTubingOd;
        data["hozTubingOd"] = this.hozTubingOd;
        data["ctWoTubingOdId"] = this.ctWoTubingOdId;
        data["hozTubingOdId"] = this.hozTubingOdId;
        data["csgId"] = this.csgId;
        data["lateralLengthEst"] = this.lateralLengthEst;
        if (Array.isArray(this.casings)) {
            data["casings"] = [];
            for (let item of this.casings)
                data["casings"].push(item ? item.toJSON() : undefined as any);
        }
        data["casingTubings"] = this.casingTubings ? this.casingTubings.toJSON() : undefined as any;
        if (Array.isArray(this.plugs)) {
            data["plugs"] = [];
            for (let item of this.plugs)
                data["plugs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.plugSets)) {
            data["plugSets"] = [];
            for (let item of this.plugSets)
                data["plugSets"].push(item ? item.toJSON() : undefined as any);
        }
        data["fracPlugStages"] = this.fracPlugStages;
        data["sitp"] = this.sitp;
        data["sicp"] = this.sicp;
        return data;
    }
}

export interface IWellInfo {
    name?: string | undefined;
    wellType?: string | undefined;
    xoEot?: number | undefined;
    kop?: number | undefined;
    thirtyDegree?: number | undefined;
    sixtyDegree?: number | undefined;
    tvd?: number | undefined;
    md?: number | undefined;
    coilCapacity?: number | undefined;
    stringType?: string | undefined;
    ctWoTubingOd?: number | undefined;
    hozTubingOd?: number | undefined;
    ctWoTubingOdId?: number | undefined;
    hozTubingOdId?: number | undefined;
    csgId?: number | undefined;
    lateralLengthEst?: number | undefined;
    casings?: ICasing[] | undefined;
    casingTubings?: ICasingTubings | undefined;
    plugs?: IPlug[] | undefined;
    plugSets?: IPlugSet[] | undefined;
    fracPlugStages?: number | undefined;
    sitp?: number | undefined;
    sicp?: number | undefined;
}

export class Casing implements ICasing {
    number!: number;
    type?: string | undefined;
    innerDiameter?: number | undefined;
    length?: number | undefined;
    volume?: number | undefined;
    direction?: string | undefined;

    constructor(data?: ICasing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.type = _data["type"];
            this.innerDiameter = _data["innerDiameter"];
            this.length = _data["length"];
            this.volume = _data["volume"];
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): Casing {
        data = typeof data === 'object' ? data : {};
        let result = new Casing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["type"] = this.type;
        data["innerDiameter"] = this.innerDiameter;
        data["length"] = this.length;
        data["volume"] = this.volume;
        data["direction"] = this.direction;
        return data;
    }
}

export interface ICasing {
    number: number;
    type?: string | undefined;
    innerDiameter?: number | undefined;
    length?: number | undefined;
    volume?: number | undefined;
    direction?: string | undefined;
}

export class CasingTubings implements ICasingTubings {
    tubing1?: CasingTubingDetail | undefined;
    tubing2?: CasingTubingDetail | undefined;
    casing1Vertical?: CasingTubingDetail | undefined;
    casing2Vertical?: CasingTubingDetail | undefined;
    casing1Horizontal?: CasingTubingDetail | undefined;
    casing2Horizontal?: CasingTubingDetail | undefined;

    constructor(data?: ICasingTubings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.tubing1 = data.tubing1 && !(data.tubing1 as any).toJSON ? new CasingTubingDetail(data.tubing1) : this.tubing1 as CasingTubingDetail;
            this.tubing2 = data.tubing2 && !(data.tubing2 as any).toJSON ? new CasingTubingDetail(data.tubing2) : this.tubing2 as CasingTubingDetail;
            this.casing1Vertical = data.casing1Vertical && !(data.casing1Vertical as any).toJSON ? new CasingTubingDetail(data.casing1Vertical) : this.casing1Vertical as CasingTubingDetail;
            this.casing2Vertical = data.casing2Vertical && !(data.casing2Vertical as any).toJSON ? new CasingTubingDetail(data.casing2Vertical) : this.casing2Vertical as CasingTubingDetail;
            this.casing1Horizontal = data.casing1Horizontal && !(data.casing1Horizontal as any).toJSON ? new CasingTubingDetail(data.casing1Horizontal) : this.casing1Horizontal as CasingTubingDetail;
            this.casing2Horizontal = data.casing2Horizontal && !(data.casing2Horizontal as any).toJSON ? new CasingTubingDetail(data.casing2Horizontal) : this.casing2Horizontal as CasingTubingDetail;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tubing1 = _data["tubing1"] ? CasingTubingDetail.fromJS(_data["tubing1"]) : undefined as any;
            this.tubing2 = _data["tubing2"] ? CasingTubingDetail.fromJS(_data["tubing2"]) : undefined as any;
            this.casing1Vertical = _data["casing1Vertical"] ? CasingTubingDetail.fromJS(_data["casing1Vertical"]) : undefined as any;
            this.casing2Vertical = _data["casing2Vertical"] ? CasingTubingDetail.fromJS(_data["casing2Vertical"]) : undefined as any;
            this.casing1Horizontal = _data["casing1Horizontal"] ? CasingTubingDetail.fromJS(_data["casing1Horizontal"]) : undefined as any;
            this.casing2Horizontal = _data["casing2Horizontal"] ? CasingTubingDetail.fromJS(_data["casing2Horizontal"]) : undefined as any;
        }
    }

    static fromJS(data: any): CasingTubings {
        data = typeof data === 'object' ? data : {};
        let result = new CasingTubings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tubing1"] = this.tubing1 ? this.tubing1.toJSON() : undefined as any;
        data["tubing2"] = this.tubing2 ? this.tubing2.toJSON() : undefined as any;
        data["casing1Vertical"] = this.casing1Vertical ? this.casing1Vertical.toJSON() : undefined as any;
        data["casing2Vertical"] = this.casing2Vertical ? this.casing2Vertical.toJSON() : undefined as any;
        data["casing1Horizontal"] = this.casing1Horizontal ? this.casing1Horizontal.toJSON() : undefined as any;
        data["casing2Horizontal"] = this.casing2Horizontal ? this.casing2Horizontal.toJSON() : undefined as any;
        return data;
    }
}

export interface ICasingTubings {
    tubing1?: ICasingTubingDetail | undefined;
    tubing2?: ICasingTubingDetail | undefined;
    casing1Vertical?: ICasingTubingDetail | undefined;
    casing2Vertical?: ICasingTubingDetail | undefined;
    casing1Horizontal?: ICasingTubingDetail | undefined;
    casing2Horizontal?: ICasingTubingDetail | undefined;
}

export class CasingTubingDetail implements ICasingTubingDetail {
    type?: string | undefined;
    length?: number | undefined;
    volume?: number | undefined;
    innerDiameter?: number | undefined;

    constructor(data?: ICasingTubingDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.length = _data["length"];
            this.volume = _data["volume"];
            this.innerDiameter = _data["innerDiameter"];
        }
    }

    static fromJS(data: any): CasingTubingDetail {
        data = typeof data === 'object' ? data : {};
        let result = new CasingTubingDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["length"] = this.length;
        data["volume"] = this.volume;
        data["innerDiameter"] = this.innerDiameter;
        return data;
    }
}

export interface ICasingTubingDetail {
    type?: string | undefined;
    length?: number | undefined;
    volume?: number | undefined;
    innerDiameter?: number | undefined;
}

export class Plug implements IPlug {
    number!: number;
    depth?: number | undefined;
    perfTop?: string | undefined;
    perfBottom?: string | undefined;

    constructor(data?: IPlug) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.depth = _data["depth"];
            this.perfTop = _data["perfTop"];
            this.perfBottom = _data["perfBottom"];
        }
    }

    static fromJS(data: any): Plug {
        data = typeof data === 'object' ? data : {};
        let result = new Plug();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["depth"] = this.depth;
        data["perfTop"] = this.perfTop;
        data["perfBottom"] = this.perfBottom;
        return data;
    }
}

export interface IPlug {
    number: number;
    depth?: number | undefined;
    perfTop?: string | undefined;
    perfBottom?: string | undefined;
}

export class PlugSet implements IPlugSet {
    plugs?: Plug[] | undefined;
    manufacturer?: string | undefined;
    model?: string | undefined;
    type?: string | undefined;

    constructor(data?: IPlugSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.plugs) {
                this.plugs = [];
                for (let i = 0; i < data.plugs.length; i++) {
                    let item = data.plugs[i];
                    this.plugs[i] = item && !(item as any).toJSON ? new Plug(item) : item as Plug;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["plugs"])) {
                this.plugs = [] as any;
                for (let item of _data["plugs"])
                    this.plugs!.push(Plug.fromJS(item));
            }
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PlugSet {
        data = typeof data === 'object' ? data : {};
        let result = new PlugSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plugs)) {
            data["plugs"] = [];
            for (let item of this.plugs)
                data["plugs"].push(item ? item.toJSON() : undefined as any);
        }
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["type"] = this.type;
        return data;
    }
}

export interface IPlugSet {
    plugs?: IPlug[] | undefined;
    manufacturer?: string | undefined;
    model?: string | undefined;
    type?: string | undefined;
}

export class FluidInfo implements IFluidInfo {
    chlorides?: number | undefined;
    naCl?: number | undefined;
    density?: number | undefined;
    hardness?: number | undefined;
    iron?: number | undefined;
    sulfates?: number | undefined;
    alkalinitty?: number | undefined;
    ph?: number | undefined;

    constructor(data?: IFluidInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chlorides = _data["chlorides"];
            this.naCl = _data["naCl"];
            this.density = _data["density"];
            this.hardness = _data["hardness"];
            this.iron = _data["iron"];
            this.sulfates = _data["sulfates"];
            this.alkalinitty = _data["alkalinitty"];
            this.ph = _data["ph"];
        }
    }

    static fromJS(data: any): FluidInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FluidInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chlorides"] = this.chlorides;
        data["naCl"] = this.naCl;
        data["density"] = this.density;
        data["hardness"] = this.hardness;
        data["iron"] = this.iron;
        data["sulfates"] = this.sulfates;
        data["alkalinitty"] = this.alkalinitty;
        data["ph"] = this.ph;
        return data;
    }
}

export interface IFluidInfo {
    chlorides?: number | undefined;
    naCl?: number | undefined;
    density?: number | undefined;
    hardness?: number | undefined;
    iron?: number | undefined;
    sulfates?: number | undefined;
    alkalinitty?: number | undefined;
    ph?: number | undefined;
}

export class PerformanceSummary implements IPerformanceSummary {
    plugsDrilled?: number | undefined;
    jobTime?: number | undefined;
    shortTrips?: number | undefined;
    plugPerShortTrip?: number | undefined;
    timePerPlug?: number | undefined;
    totalRunningPipe?: number | undefined;
    runningFtMdRatio?: number | undefined;
    productiveFtPerHour?: number | undefined;

    constructor(data?: IPerformanceSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plugsDrilled = _data["plugsDrilled"];
            this.jobTime = _data["jobTime"];
            this.shortTrips = _data["shortTrips"];
            this.plugPerShortTrip = _data["plugPerShortTrip"];
            this.timePerPlug = _data["timePerPlug"];
            this.totalRunningPipe = _data["totalRunningPipe"];
            this.runningFtMdRatio = _data["runningFtMdRatio"];
            this.productiveFtPerHour = _data["productiveFtPerHour"];
        }
    }

    static fromJS(data: any): PerformanceSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plugsDrilled"] = this.plugsDrilled;
        data["jobTime"] = this.jobTime;
        data["shortTrips"] = this.shortTrips;
        data["plugPerShortTrip"] = this.plugPerShortTrip;
        data["timePerPlug"] = this.timePerPlug;
        data["totalRunningPipe"] = this.totalRunningPipe;
        data["runningFtMdRatio"] = this.runningFtMdRatio;
        data["productiveFtPerHour"] = this.productiveFtPerHour;
        return data;
    }
}

export interface IPerformanceSummary {
    plugsDrilled?: number | undefined;
    jobTime?: number | undefined;
    shortTrips?: number | undefined;
    plugPerShortTrip?: number | undefined;
    timePerPlug?: number | undefined;
    totalRunningPipe?: number | undefined;
    runningFtMdRatio?: number | undefined;
    productiveFtPerHour?: number | undefined;
}

export class FluidSummary implements IFluidSummary {
    avgSlwRe?: number | undefined;
    avgSlwVisc?: number | undefined;
    avgAnnularVel?: number | undefined;
    bblCirculated?: number | undefined;
    numOfSweeps?: number | undefined;
    totalSweepVol?: number | undefined;
    avgSweepSize?: number | undefined;
    avgSweepVisc?: number | undefined;
    avgCtPsi?: number | undefined;
    avgWhPsi?: number | undefined;
    avgDiffPsi?: number | undefined;
    avgCtBpm?: number | undefined;
    avgFbBpm?: number | undefined;
    chemicals?: KeyValuePairOfStringAndNullableDouble[] | undefined;

    constructor(data?: IFluidSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.chemicals) {
                this.chemicals = [];
                for (let i = 0; i < data.chemicals.length; i++) {
                    let item = data.chemicals[i];
                    this.chemicals[i] = item && !(item as any).toJSON ? new KeyValuePairOfStringAndNullableDouble(item) : item as KeyValuePairOfStringAndNullableDouble;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avgSlwRe = _data["avgSlwRe"];
            this.avgSlwVisc = _data["avgSlwVisc"];
            this.avgAnnularVel = _data["avgAnnularVel"];
            this.bblCirculated = _data["bblCirculated"];
            this.numOfSweeps = _data["numOfSweeps"];
            this.totalSweepVol = _data["totalSweepVol"];
            this.avgSweepSize = _data["avgSweepSize"];
            this.avgSweepVisc = _data["avgSweepVisc"];
            this.avgCtPsi = _data["avgCtPsi"];
            this.avgWhPsi = _data["avgWhPsi"];
            this.avgDiffPsi = _data["avgDiffPsi"];
            this.avgCtBpm = _data["avgCtBpm"];
            this.avgFbBpm = _data["avgFbBpm"];
            if (Array.isArray(_data["chemicals"])) {
                this.chemicals = [] as any;
                for (let item of _data["chemicals"])
                    this.chemicals!.push(KeyValuePairOfStringAndNullableDouble.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FluidSummary {
        data = typeof data === 'object' ? data : {};
        let result = new FluidSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avgSlwRe"] = this.avgSlwRe;
        data["avgSlwVisc"] = this.avgSlwVisc;
        data["avgAnnularVel"] = this.avgAnnularVel;
        data["bblCirculated"] = this.bblCirculated;
        data["numOfSweeps"] = this.numOfSweeps;
        data["totalSweepVol"] = this.totalSweepVol;
        data["avgSweepSize"] = this.avgSweepSize;
        data["avgSweepVisc"] = this.avgSweepVisc;
        data["avgCtPsi"] = this.avgCtPsi;
        data["avgWhPsi"] = this.avgWhPsi;
        data["avgDiffPsi"] = this.avgDiffPsi;
        data["avgCtBpm"] = this.avgCtBpm;
        data["avgFbBpm"] = this.avgFbBpm;
        if (Array.isArray(this.chemicals)) {
            data["chemicals"] = [];
            for (let item of this.chemicals)
                data["chemicals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFluidSummary {
    avgSlwRe?: number | undefined;
    avgSlwVisc?: number | undefined;
    avgAnnularVel?: number | undefined;
    bblCirculated?: number | undefined;
    numOfSweeps?: number | undefined;
    totalSweepVol?: number | undefined;
    avgSweepSize?: number | undefined;
    avgSweepVisc?: number | undefined;
    avgCtPsi?: number | undefined;
    avgWhPsi?: number | undefined;
    avgDiffPsi?: number | undefined;
    avgCtBpm?: number | undefined;
    avgFbBpm?: number | undefined;
    chemicals?: IKeyValuePairOfStringAndNullableDouble[] | undefined;
}

export class KeyValuePairOfStringAndNullableDouble implements IKeyValuePairOfStringAndNullableDouble {
    key?: string | undefined;
    value?: number | undefined;

    constructor(data?: IKeyValuePairOfStringAndNullableDouble) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndNullableDouble {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndNullableDouble();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfStringAndNullableDouble {
    key?: string | undefined;
    value?: number | undefined;
}

export class JobLinker extends EntityBase implements IJobLinker {
    consumerId?: string | undefined;
    wellName?: string | undefined;
    apiNumber?: string | undefined;
    consumerJobId?: string | undefined;
    vendorJobIds?: string[] | undefined;
    jobType?: string | undefined;
    consumerJobStartTime!: Date;

    constructor(data?: IJobLinker) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.consumerId = _data["consumerId"];
            this.wellName = _data["wellName"];
            this.apiNumber = _data["apiNumber"];
            this.consumerJobId = _data["consumerJobId"];
            if (Array.isArray(_data["vendorJobIds"])) {
                this.vendorJobIds = [] as any;
                for (let item of _data["vendorJobIds"])
                    this.vendorJobIds!.push(item);
            }
            this.jobType = _data["jobType"];
            this.consumerJobStartTime = _data["consumerJobStartTime"] ? new Date(_data["consumerJobStartTime"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): JobLinker {
        data = typeof data === 'object' ? data : {};
        let result = new JobLinker();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerId"] = this.consumerId;
        data["wellName"] = this.wellName;
        data["apiNumber"] = this.apiNumber;
        data["consumerJobId"] = this.consumerJobId;
        if (Array.isArray(this.vendorJobIds)) {
            data["vendorJobIds"] = [];
            for (let item of this.vendorJobIds)
                data["vendorJobIds"].push(item);
        }
        data["jobType"] = this.jobType;
        data["consumerJobStartTime"] = this.consumerJobStartTime ? this.consumerJobStartTime.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IJobLinker extends IEntityBase {
    consumerId?: string | undefined;
    wellName?: string | undefined;
    apiNumber?: string | undefined;
    consumerJobId?: string | undefined;
    vendorJobIds?: string[] | undefined;
    jobType?: string | undefined;
    consumerJobStartTime: Date;
}

export class Ticket implements ITicket {
    name?: string | undefined;
    ticketName?: string | undefined;
    fileUri?: string | undefined;
    accounting!: boolean;
    field!: boolean;

    constructor(data?: ITicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.ticketName = _data["ticketName"];
            this.fileUri = _data["fileUri"];
            this.accounting = _data["accounting"];
            this.field = _data["field"];
        }
    }

    static fromJS(data: any): Ticket {
        data = typeof data === 'object' ? data : {};
        let result = new Ticket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ticketName"] = this.ticketName;
        data["fileUri"] = this.fileUri;
        data["accounting"] = this.accounting;
        data["field"] = this.field;
        return data;
    }
}

export interface ITicket {
    name?: string | undefined;
    ticketName?: string | undefined;
    fileUri?: string | undefined;
    accounting: boolean;
    field: boolean;
}

export class JobWorkbookConfiguration extends EntityBase implements IJobWorkbookConfiguration {
    jobId?: string | undefined;
    workbookMeasurementChannelConfigurations?: WorkbookMeasurementChannelConfiguration[] | undefined;
    unitSystem?: string | undefined;

    constructor(data?: IJobWorkbookConfiguration) {
        super(data);
        if (data) {
            if (data.workbookMeasurementChannelConfigurations) {
                this.workbookMeasurementChannelConfigurations = [];
                for (let i = 0; i < data.workbookMeasurementChannelConfigurations.length; i++) {
                    let item = data.workbookMeasurementChannelConfigurations[i];
                    this.workbookMeasurementChannelConfigurations[i] = item && !(item as any).toJSON ? new WorkbookMeasurementChannelConfiguration(item) : item as WorkbookMeasurementChannelConfiguration;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobId = _data["jobId"];
            if (Array.isArray(_data["workbookMeasurementChannelConfigurations"])) {
                this.workbookMeasurementChannelConfigurations = [] as any;
                for (let item of _data["workbookMeasurementChannelConfigurations"])
                    this.workbookMeasurementChannelConfigurations!.push(WorkbookMeasurementChannelConfiguration.fromJS(item));
            }
            this.unitSystem = _data["unitSystem"];
        }
    }

    static override fromJS(data: any): JobWorkbookConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new JobWorkbookConfiguration();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        if (Array.isArray(this.workbookMeasurementChannelConfigurations)) {
            data["workbookMeasurementChannelConfigurations"] = [];
            for (let item of this.workbookMeasurementChannelConfigurations)
                data["workbookMeasurementChannelConfigurations"].push(item ? item.toJSON() : undefined as any);
        }
        data["unitSystem"] = this.unitSystem;
        super.toJSON(data);
        return data;
    }
}

export interface IJobWorkbookConfiguration extends IEntityBase {
    jobId?: string | undefined;
    workbookMeasurementChannelConfigurations?: IWorkbookMeasurementChannelConfiguration[] | undefined;
    unitSystem?: string | undefined;
}

export class NewCompanyRequest extends BaseRequest implements INewCompanyRequest {
    companyName?: string | undefined;
    companyPrefix?: string | undefined;
    companyType?: string | undefined;
    companyUnitSystem?: string | undefined;
    autoApprovedEmailDomains?: string[] | undefined;
    billingAddress?: Address | undefined;
    shippingAddress?: Address | undefined;

    constructor(data?: INewCompanyRequest) {
        super(data);
        if (data) {
            this.billingAddress = data.billingAddress && !(data.billingAddress as any).toJSON ? new Address(data.billingAddress) : this.billingAddress as Address;
            this.shippingAddress = data.shippingAddress && !(data.shippingAddress as any).toJSON ? new Address(data.shippingAddress) : this.shippingAddress as Address;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyName = _data["companyName"];
            this.companyPrefix = _data["companyPrefix"];
            this.companyType = _data["companyType"];
            this.companyUnitSystem = _data["companyUnitSystem"];
            if (Array.isArray(_data["autoApprovedEmailDomains"])) {
                this.autoApprovedEmailDomains = [] as any;
                for (let item of _data["autoApprovedEmailDomains"])
                    this.autoApprovedEmailDomains!.push(item);
            }
            this.billingAddress = _data["billingAddress"] ? Address.fromJS(_data["billingAddress"]) : undefined as any;
            this.shippingAddress = _data["shippingAddress"] ? Address.fromJS(_data["shippingAddress"]) : undefined as any;
        }
    }

    static override fromJS(data: any): NewCompanyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NewCompanyRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["companyPrefix"] = this.companyPrefix;
        data["companyType"] = this.companyType;
        data["companyUnitSystem"] = this.companyUnitSystem;
        if (Array.isArray(this.autoApprovedEmailDomains)) {
            data["autoApprovedEmailDomains"] = [];
            for (let item of this.autoApprovedEmailDomains)
                data["autoApprovedEmailDomains"].push(item);
        }
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : undefined as any;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface INewCompanyRequest extends IBaseRequest {
    companyName?: string | undefined;
    companyPrefix?: string | undefined;
    companyType?: string | undefined;
    companyUnitSystem?: string | undefined;
    autoApprovedEmailDomains?: string[] | undefined;
    billingAddress?: IAddress | undefined;
    shippingAddress?: IAddress | undefined;
}

export class ShiftSummary extends EntityBase implements IShiftSummary {
    jobId?: string | undefined;
    companyId?: string | undefined;
    shiftStartUtc!: Date;
    shiftEndUtc!: Date;
    dayNight?: string | undefined;
    totalHoursWorked!: number;
    crewMembers?: string | undefined;
    crewMemberUserIds?: string[] | undefined;
    currentStatus?: string | undefined;
    safetyTopicsDiscussed?: string | undefined;
    anySafetyIncidents?: boolean | undefined;
    safetyIncidentDetails?: string | undefined;
    safetyIncidents?: string[] | undefined;
    jobStatus?: string | undefined;
    customerFeedback?: string | undefined;
    mechanicalNeeds?: string | undefined;
    nextPlannedWork?: string | undefined;
    dataComponentsWorking?: boolean | undefined;
    dataComponentsContext?: string | undefined;
    summaryProfile?: ShiftSummaryProfile | undefined;
    fluidType?: string | undefined;
    currentFluidSystem?: string | undefined;
    foamStabilityMinutes?: number | undefined;
    sandSuspensionMinutes?: number | undefined;
    partCTestStatus?: ShiftSummaryPartCTestStatus | undefined;
    gramsToPass?: number | undefined;
    waterLeakOff?: number | undefined;
    iscavGallonsConsumed?: number | undefined;
    procideGallonsConsumed?: number | undefined;
    fuelProvidedByCustomer?: boolean | undefined;
    attachments?: ShiftSummaryAttachment[] | undefined;
    isSubmitted!: boolean;
    submittedAtUtc?: Date | undefined;
    submittedBy?: string | undefined;
    outputSnapshot?: ShiftSummaryOutputSnapshot | undefined;

    constructor(data?: IShiftSummary) {
        super(data);
        if (data) {
            if (data.attachments) {
                this.attachments = [];
                for (let i = 0; i < data.attachments.length; i++) {
                    let item = data.attachments[i];
                    this.attachments[i] = item && !(item as any).toJSON ? new ShiftSummaryAttachment(item) : item as ShiftSummaryAttachment;
                }
            }
            this.outputSnapshot = data.outputSnapshot && !(data.outputSnapshot as any).toJSON ? new ShiftSummaryOutputSnapshot(data.outputSnapshot) : this.outputSnapshot as ShiftSummaryOutputSnapshot;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobId = _data["jobId"];
            this.companyId = _data["companyId"];
            this.shiftStartUtc = _data["shiftStartUtc"] ? new Date(_data["shiftStartUtc"].toString()) : undefined as any;
            this.shiftEndUtc = _data["shiftEndUtc"] ? new Date(_data["shiftEndUtc"].toString()) : undefined as any;
            this.dayNight = _data["dayNight"];
            this.totalHoursWorked = _data["totalHoursWorked"];
            this.crewMembers = _data["crewMembers"];
            if (Array.isArray(_data["crewMemberUserIds"])) {
                this.crewMemberUserIds = [] as any;
                for (let item of _data["crewMemberUserIds"])
                    this.crewMemberUserIds!.push(item);
            }
            this.currentStatus = _data["currentStatus"];
            this.safetyTopicsDiscussed = _data["safetyTopicsDiscussed"];
            this.anySafetyIncidents = _data["anySafetyIncidents"];
            this.safetyIncidentDetails = _data["safetyIncidentDetails"];
            if (Array.isArray(_data["safetyIncidents"])) {
                this.safetyIncidents = [] as any;
                for (let item of _data["safetyIncidents"])
                    this.safetyIncidents!.push(item);
            }
            this.jobStatus = _data["jobStatus"];
            this.customerFeedback = _data["customerFeedback"];
            this.mechanicalNeeds = _data["mechanicalNeeds"];
            this.nextPlannedWork = _data["nextPlannedWork"];
            this.dataComponentsWorking = _data["dataComponentsWorking"];
            this.dataComponentsContext = _data["dataComponentsContext"];
            this.summaryProfile = _data["summaryProfile"];
            this.fluidType = _data["fluidType"];
            this.currentFluidSystem = _data["currentFluidSystem"];
            this.foamStabilityMinutes = _data["foamStabilityMinutes"];
            this.sandSuspensionMinutes = _data["sandSuspensionMinutes"];
            this.partCTestStatus = _data["partCTestStatus"];
            this.gramsToPass = _data["gramsToPass"];
            this.waterLeakOff = _data["waterLeakOff"];
            this.iscavGallonsConsumed = _data["iscavGallonsConsumed"];
            this.procideGallonsConsumed = _data["procideGallonsConsumed"];
            this.fuelProvidedByCustomer = _data["fuelProvidedByCustomer"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(ShiftSummaryAttachment.fromJS(item));
            }
            this.isSubmitted = _data["isSubmitted"];
            this.submittedAtUtc = _data["submittedAtUtc"] ? new Date(_data["submittedAtUtc"].toString()) : undefined as any;
            this.submittedBy = _data["submittedBy"];
            this.outputSnapshot = _data["outputSnapshot"] ? ShiftSummaryOutputSnapshot.fromJS(_data["outputSnapshot"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ShiftSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSummary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["companyId"] = this.companyId;
        data["shiftStartUtc"] = this.shiftStartUtc ? this.shiftStartUtc.toISOString() : undefined as any;
        data["shiftEndUtc"] = this.shiftEndUtc ? this.shiftEndUtc.toISOString() : undefined as any;
        data["dayNight"] = this.dayNight;
        data["totalHoursWorked"] = this.totalHoursWorked;
        data["crewMembers"] = this.crewMembers;
        if (Array.isArray(this.crewMemberUserIds)) {
            data["crewMemberUserIds"] = [];
            for (let item of this.crewMemberUserIds)
                data["crewMemberUserIds"].push(item);
        }
        data["currentStatus"] = this.currentStatus;
        data["safetyTopicsDiscussed"] = this.safetyTopicsDiscussed;
        data["anySafetyIncidents"] = this.anySafetyIncidents;
        data["safetyIncidentDetails"] = this.safetyIncidentDetails;
        if (Array.isArray(this.safetyIncidents)) {
            data["safetyIncidents"] = [];
            for (let item of this.safetyIncidents)
                data["safetyIncidents"].push(item);
        }
        data["jobStatus"] = this.jobStatus;
        data["customerFeedback"] = this.customerFeedback;
        data["mechanicalNeeds"] = this.mechanicalNeeds;
        data["nextPlannedWork"] = this.nextPlannedWork;
        data["dataComponentsWorking"] = this.dataComponentsWorking;
        data["dataComponentsContext"] = this.dataComponentsContext;
        data["summaryProfile"] = this.summaryProfile;
        data["fluidType"] = this.fluidType;
        data["currentFluidSystem"] = this.currentFluidSystem;
        data["foamStabilityMinutes"] = this.foamStabilityMinutes;
        data["sandSuspensionMinutes"] = this.sandSuspensionMinutes;
        data["partCTestStatus"] = this.partCTestStatus;
        data["gramsToPass"] = this.gramsToPass;
        data["waterLeakOff"] = this.waterLeakOff;
        data["iscavGallonsConsumed"] = this.iscavGallonsConsumed;
        data["procideGallonsConsumed"] = this.procideGallonsConsumed;
        data["fuelProvidedByCustomer"] = this.fuelProvidedByCustomer;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSubmitted"] = this.isSubmitted;
        data["submittedAtUtc"] = this.submittedAtUtc ? this.submittedAtUtc.toISOString() : undefined as any;
        data["submittedBy"] = this.submittedBy;
        data["outputSnapshot"] = this.outputSnapshot ? this.outputSnapshot.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IShiftSummary extends IEntityBase {
    jobId?: string | undefined;
    companyId?: string | undefined;
    shiftStartUtc: Date;
    shiftEndUtc: Date;
    dayNight?: string | undefined;
    totalHoursWorked: number;
    crewMembers?: string | undefined;
    crewMemberUserIds?: string[] | undefined;
    currentStatus?: string | undefined;
    safetyTopicsDiscussed?: string | undefined;
    anySafetyIncidents?: boolean | undefined;
    safetyIncidentDetails?: string | undefined;
    safetyIncidents?: string[] | undefined;
    jobStatus?: string | undefined;
    customerFeedback?: string | undefined;
    mechanicalNeeds?: string | undefined;
    nextPlannedWork?: string | undefined;
    dataComponentsWorking?: boolean | undefined;
    dataComponentsContext?: string | undefined;
    summaryProfile?: ShiftSummaryProfile | undefined;
    fluidType?: string | undefined;
    currentFluidSystem?: string | undefined;
    foamStabilityMinutes?: number | undefined;
    sandSuspensionMinutes?: number | undefined;
    partCTestStatus?: ShiftSummaryPartCTestStatus | undefined;
    gramsToPass?: number | undefined;
    waterLeakOff?: number | undefined;
    iscavGallonsConsumed?: number | undefined;
    procideGallonsConsumed?: number | undefined;
    fuelProvidedByCustomer?: boolean | undefined;
    attachments?: IShiftSummaryAttachment[] | undefined;
    isSubmitted: boolean;
    submittedAtUtc?: Date | undefined;
    submittedBy?: string | undefined;
    outputSnapshot?: IShiftSummaryOutputSnapshot | undefined;
}

export enum ShiftSummaryProfile {
    HydroLyft = 0,
    DrilloutWashout = 1,
}

export enum ShiftSummaryPartCTestStatus {
    Yes = 0,
    No = 1,
    NoLcmUsePlanned = 2,
}

export class ShiftSummaryAttachment implements IShiftSummaryAttachment {
    id?: string | undefined;
    fileName?: string | undefined;
    description?: string | undefined;
    contentType?: string | undefined;
    sizeBytes!: number;
    uploadedAtUtc!: Date;
    blobName?: string | undefined;

    constructor(data?: IShiftSummaryAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.description = _data["description"];
            this.contentType = _data["contentType"];
            this.sizeBytes = _data["sizeBytes"];
            this.uploadedAtUtc = _data["uploadedAtUtc"] ? new Date(_data["uploadedAtUtc"].toString()) : undefined as any;
            this.blobName = _data["blobName"];
        }
    }

    static fromJS(data: any): ShiftSummaryAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSummaryAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["description"] = this.description;
        data["contentType"] = this.contentType;
        data["sizeBytes"] = this.sizeBytes;
        data["uploadedAtUtc"] = this.uploadedAtUtc ? this.uploadedAtUtc.toISOString() : undefined as any;
        data["blobName"] = this.blobName;
        return data;
    }
}

export interface IShiftSummaryAttachment {
    id?: string | undefined;
    fileName?: string | undefined;
    description?: string | undefined;
    contentType?: string | undefined;
    sizeBytes: number;
    uploadedAtUtc: Date;
    blobName?: string | undefined;
}

export class ShiftSummaryOutputSnapshot implements IShiftSummaryOutputSnapshot {
    customer?: string | undefined;
    essJobNumber?: string | undefined;
    wellName?: string | undefined;
    district?: string | undefined;
    ctWorProvider?: string | undefined;
    dhToolProvider?: string | undefined;
    tubingUnitDescription?: string | undefined;
    flowbackProvider?: string | undefined;
    pbtd?: number | undefined;
    currentDepth?: number | undefined;
    deepestDepthRecorded?: number | undefined;
    footageMovedDuringShift?: number | undefined;
    ropOverShift?: number | undefined;
    footageRemaining?: number | undefined;
    plugsInWell?: number | undefined;
    totalPlugsMilled?: number | undefined;
    plugsRemaining?: number | undefined;
    dashboardUrl?: string | undefined;
    workbookType?: string | undefined;
    isFrcsDrilloutWashout!: boolean;
    outputTitle?: string | undefined;
    reportDateTimeUtc!: Date;
    chemicalDosageParquetBlobPath?: string | undefined;
    liveDataPushedPercent?: number | undefined;
    devicePushStatuses?: ShiftSummaryDevicePushStatus[] | undefined;
    totalBblsPumpedOverShift?: number | undefined;
    liveDataReport?: ShiftSummaryMetricRow[] | undefined;
    workbookDataReport?: ShiftSummaryWorkbookMetricRow[] | undefined;
    lcmReport?: ShiftSummaryLcmReport | undefined;

    constructor(data?: IShiftSummaryOutputSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.devicePushStatuses) {
                this.devicePushStatuses = [];
                for (let i = 0; i < data.devicePushStatuses.length; i++) {
                    let item = data.devicePushStatuses[i];
                    this.devicePushStatuses[i] = item && !(item as any).toJSON ? new ShiftSummaryDevicePushStatus(item) : item as ShiftSummaryDevicePushStatus;
                }
            }
            if (data.liveDataReport) {
                this.liveDataReport = [];
                for (let i = 0; i < data.liveDataReport.length; i++) {
                    let item = data.liveDataReport[i];
                    this.liveDataReport[i] = item && !(item as any).toJSON ? new ShiftSummaryMetricRow(item) : item as ShiftSummaryMetricRow;
                }
            }
            if (data.workbookDataReport) {
                this.workbookDataReport = [];
                for (let i = 0; i < data.workbookDataReport.length; i++) {
                    let item = data.workbookDataReport[i];
                    this.workbookDataReport[i] = item && !(item as any).toJSON ? new ShiftSummaryWorkbookMetricRow(item) : item as ShiftSummaryWorkbookMetricRow;
                }
            }
            this.lcmReport = data.lcmReport && !(data.lcmReport as any).toJSON ? new ShiftSummaryLcmReport(data.lcmReport) : this.lcmReport as ShiftSummaryLcmReport;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"];
            this.essJobNumber = _data["essJobNumber"];
            this.wellName = _data["wellName"];
            this.district = _data["district"];
            this.ctWorProvider = _data["ctWorProvider"];
            this.dhToolProvider = _data["dhToolProvider"];
            this.tubingUnitDescription = _data["tubingUnitDescription"];
            this.flowbackProvider = _data["flowbackProvider"];
            this.pbtd = _data["pbtd"];
            this.currentDepth = _data["currentDepth"];
            this.deepestDepthRecorded = _data["deepestDepthRecorded"];
            this.footageMovedDuringShift = _data["footageMovedDuringShift"];
            this.ropOverShift = _data["ropOverShift"];
            this.footageRemaining = _data["footageRemaining"];
            this.plugsInWell = _data["plugsInWell"];
            this.totalPlugsMilled = _data["totalPlugsMilled"];
            this.plugsRemaining = _data["plugsRemaining"];
            this.dashboardUrl = _data["dashboardUrl"];
            this.workbookType = _data["workbookType"];
            this.isFrcsDrilloutWashout = _data["isFrcsDrilloutWashout"];
            this.outputTitle = _data["outputTitle"];
            this.reportDateTimeUtc = _data["reportDateTimeUtc"] ? new Date(_data["reportDateTimeUtc"].toString()) : undefined as any;
            this.chemicalDosageParquetBlobPath = _data["chemicalDosageParquetBlobPath"];
            this.liveDataPushedPercent = _data["liveDataPushedPercent"];
            if (Array.isArray(_data["devicePushStatuses"])) {
                this.devicePushStatuses = [] as any;
                for (let item of _data["devicePushStatuses"])
                    this.devicePushStatuses!.push(ShiftSummaryDevicePushStatus.fromJS(item));
            }
            this.totalBblsPumpedOverShift = _data["totalBblsPumpedOverShift"];
            if (Array.isArray(_data["liveDataReport"])) {
                this.liveDataReport = [] as any;
                for (let item of _data["liveDataReport"])
                    this.liveDataReport!.push(ShiftSummaryMetricRow.fromJS(item));
            }
            if (Array.isArray(_data["workbookDataReport"])) {
                this.workbookDataReport = [] as any;
                for (let item of _data["workbookDataReport"])
                    this.workbookDataReport!.push(ShiftSummaryWorkbookMetricRow.fromJS(item));
            }
            this.lcmReport = _data["lcmReport"] ? ShiftSummaryLcmReport.fromJS(_data["lcmReport"]) : undefined as any;
        }
    }

    static fromJS(data: any): ShiftSummaryOutputSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSummaryOutputSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer;
        data["essJobNumber"] = this.essJobNumber;
        data["wellName"] = this.wellName;
        data["district"] = this.district;
        data["ctWorProvider"] = this.ctWorProvider;
        data["dhToolProvider"] = this.dhToolProvider;
        data["tubingUnitDescription"] = this.tubingUnitDescription;
        data["flowbackProvider"] = this.flowbackProvider;
        data["pbtd"] = this.pbtd;
        data["currentDepth"] = this.currentDepth;
        data["deepestDepthRecorded"] = this.deepestDepthRecorded;
        data["footageMovedDuringShift"] = this.footageMovedDuringShift;
        data["ropOverShift"] = this.ropOverShift;
        data["footageRemaining"] = this.footageRemaining;
        data["plugsInWell"] = this.plugsInWell;
        data["totalPlugsMilled"] = this.totalPlugsMilled;
        data["plugsRemaining"] = this.plugsRemaining;
        data["dashboardUrl"] = this.dashboardUrl;
        data["workbookType"] = this.workbookType;
        data["isFrcsDrilloutWashout"] = this.isFrcsDrilloutWashout;
        data["outputTitle"] = this.outputTitle;
        data["reportDateTimeUtc"] = this.reportDateTimeUtc ? this.reportDateTimeUtc.toISOString() : undefined as any;
        data["chemicalDosageParquetBlobPath"] = this.chemicalDosageParquetBlobPath;
        data["liveDataPushedPercent"] = this.liveDataPushedPercent;
        if (Array.isArray(this.devicePushStatuses)) {
            data["devicePushStatuses"] = [];
            for (let item of this.devicePushStatuses)
                data["devicePushStatuses"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalBblsPumpedOverShift"] = this.totalBblsPumpedOverShift;
        if (Array.isArray(this.liveDataReport)) {
            data["liveDataReport"] = [];
            for (let item of this.liveDataReport)
                data["liveDataReport"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workbookDataReport)) {
            data["workbookDataReport"] = [];
            for (let item of this.workbookDataReport)
                data["workbookDataReport"].push(item ? item.toJSON() : undefined as any);
        }
        data["lcmReport"] = this.lcmReport ? this.lcmReport.toJSON() : undefined as any;
        return data;
    }
}

export interface IShiftSummaryOutputSnapshot {
    customer?: string | undefined;
    essJobNumber?: string | undefined;
    wellName?: string | undefined;
    district?: string | undefined;
    ctWorProvider?: string | undefined;
    dhToolProvider?: string | undefined;
    tubingUnitDescription?: string | undefined;
    flowbackProvider?: string | undefined;
    pbtd?: number | undefined;
    currentDepth?: number | undefined;
    deepestDepthRecorded?: number | undefined;
    footageMovedDuringShift?: number | undefined;
    ropOverShift?: number | undefined;
    footageRemaining?: number | undefined;
    plugsInWell?: number | undefined;
    totalPlugsMilled?: number | undefined;
    plugsRemaining?: number | undefined;
    dashboardUrl?: string | undefined;
    workbookType?: string | undefined;
    isFrcsDrilloutWashout: boolean;
    outputTitle?: string | undefined;
    reportDateTimeUtc: Date;
    chemicalDosageParquetBlobPath?: string | undefined;
    liveDataPushedPercent?: number | undefined;
    devicePushStatuses?: IShiftSummaryDevicePushStatus[] | undefined;
    totalBblsPumpedOverShift?: number | undefined;
    liveDataReport?: IShiftSummaryMetricRow[] | undefined;
    workbookDataReport?: IShiftSummaryWorkbookMetricRow[] | undefined;
    lcmReport?: IShiftSummaryLcmReport | undefined;
}

export class ShiftSummaryDevicePushStatus implements IShiftSummaryDevicePushStatus {
    deviceId?: string | undefined;
    deviceName?: string | undefined;
    lastDataPushedAtUtc?: Date | undefined;

    constructor(data?: IShiftSummaryDevicePushStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.deviceName = _data["deviceName"];
            this.lastDataPushedAtUtc = _data["lastDataPushedAtUtc"] ? new Date(_data["lastDataPushedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ShiftSummaryDevicePushStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSummaryDevicePushStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["lastDataPushedAtUtc"] = this.lastDataPushedAtUtc ? this.lastDataPushedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IShiftSummaryDevicePushStatus {
    deviceId?: string | undefined;
    deviceName?: string | undefined;
    lastDataPushedAtUtc?: Date | undefined;
}

export class ShiftSummaryMetricRow implements IShiftSummaryMetricRow {
    metricLabel?: string | undefined;
    current?: number | undefined;
    avgOverShift?: number | undefined;

    constructor(data?: IShiftSummaryMetricRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metricLabel = _data["metricLabel"];
            this.current = _data["current"];
            this.avgOverShift = _data["avgOverShift"];
        }
    }

    static fromJS(data: any): ShiftSummaryMetricRow {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSummaryMetricRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metricLabel"] = this.metricLabel;
        data["current"] = this.current;
        data["avgOverShift"] = this.avgOverShift;
        return data;
    }
}

export interface IShiftSummaryMetricRow {
    metricLabel?: string | undefined;
    current?: number | undefined;
    avgOverShift?: number | undefined;
}

export class ShiftSummaryWorkbookMetricRow implements IShiftSummaryWorkbookMetricRow {
    metricLabel?: string | undefined;
    numberOfEntries?: number | undefined;
    current?: number | undefined;
    avgOverShift?: number | undefined;

    constructor(data?: IShiftSummaryWorkbookMetricRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metricLabel = _data["metricLabel"];
            this.numberOfEntries = _data["numberOfEntries"];
            this.current = _data["current"];
            this.avgOverShift = _data["avgOverShift"];
        }
    }

    static fromJS(data: any): ShiftSummaryWorkbookMetricRow {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSummaryWorkbookMetricRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metricLabel"] = this.metricLabel;
        data["numberOfEntries"] = this.numberOfEntries;
        data["current"] = this.current;
        data["avgOverShift"] = this.avgOverShift;
        return data;
    }
}

export interface IShiftSummaryWorkbookMetricRow {
    metricLabel?: string | undefined;
    numberOfEntries?: number | undefined;
    current?: number | undefined;
    avgOverShift?: number | undefined;
}

export class ShiftSummaryLcmReport implements IShiftSummaryLcmReport {
    bblsOfLcmPumped?: number | undefined;
    lbsOfPartC?: number | undefined;
    avgLbsPartCPerBbl?: number | undefined;
    lbsOfObp?: number | undefined;
    avgLbsObpPerBbl?: number | undefined;
    lbsOfFiber?: number | undefined;
    avgLbsFiberPerBbl?: number | undefined;

    constructor(data?: IShiftSummaryLcmReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bblsOfLcmPumped = _data["bblsOfLcmPumped"];
            this.lbsOfPartC = _data["lbsOfPartC"];
            this.avgLbsPartCPerBbl = _data["avgLbsPartCPerBbl"];
            this.lbsOfObp = _data["lbsOfObp"];
            this.avgLbsObpPerBbl = _data["avgLbsObpPerBbl"];
            this.lbsOfFiber = _data["lbsOfFiber"];
            this.avgLbsFiberPerBbl = _data["avgLbsFiberPerBbl"];
        }
    }

    static fromJS(data: any): ShiftSummaryLcmReport {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSummaryLcmReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bblsOfLcmPumped"] = this.bblsOfLcmPumped;
        data["lbsOfPartC"] = this.lbsOfPartC;
        data["avgLbsPartCPerBbl"] = this.avgLbsPartCPerBbl;
        data["lbsOfObp"] = this.lbsOfObp;
        data["avgLbsObpPerBbl"] = this.avgLbsObpPerBbl;
        data["lbsOfFiber"] = this.lbsOfFiber;
        data["avgLbsFiberPerBbl"] = this.avgLbsFiberPerBbl;
        return data;
    }
}

export interface IShiftSummaryLcmReport {
    bblsOfLcmPumped?: number | undefined;
    lbsOfPartC?: number | undefined;
    avgLbsPartCPerBbl?: number | undefined;
    lbsOfObp?: number | undefined;
    avgLbsObpPerBbl?: number | undefined;
    lbsOfFiber?: number | undefined;
    avgLbsFiberPerBbl?: number | undefined;
}

export class SimulationHeader implements ISimulationHeader {
    simulationId?: string | undefined;
    customer?: CompanyNameViewModel | undefined;
    name?: string | undefined;
    companyId?: string | undefined;
    majorVersion!: number;
    minorVersion!: number;
    revisionVersion!: number;
    timestamp!: number;

    constructor(data?: ISimulationHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.customer = data.customer && !(data.customer as any).toJSON ? new CompanyNameViewModel(data.customer) : this.customer as CompanyNameViewModel;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.simulationId = _data["simulationId"];
            this.customer = _data["customer"] ? CompanyNameViewModel.fromJS(_data["customer"]) : undefined as any;
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
            this.revisionVersion = _data["revisionVersion"];
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): SimulationHeader {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["simulationId"] = this.simulationId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        data["revisionVersion"] = this.revisionVersion;
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface ISimulationHeader {
    simulationId?: string | undefined;
    customer?: ICompanyNameViewModel | undefined;
    name?: string | undefined;
    companyId?: string | undefined;
    majorVersion: number;
    minorVersion: number;
    revisionVersion: number;
    timestamp: number;
}

export class Simulation extends EntityBase implements ISimulation {
    activities?: SimulationActivity[] | undefined;
    chemicals?: SimulationChemical[] | undefined;
    defaults?: SimulationDefault | undefined;
    expenses?: SimulationExpense[] | undefined;
    fluidSummary?: SimulationFluidSummary | undefined;
    goals?: SimulationGoals | undefined;
    header?: SimulationHeader | undefined;
    performance?: PerformanceSummary | undefined;
    siteDetails?: SimulationSiteDetails | undefined;
    wellInfo?: WellInfo | undefined;

    constructor(data?: ISimulation) {
        super(data);
        if (data) {
            if (data.activities) {
                this.activities = [];
                for (let i = 0; i < data.activities.length; i++) {
                    let item = data.activities[i];
                    this.activities[i] = item && !(item as any).toJSON ? new SimulationActivity(item) : item as SimulationActivity;
                }
            }
            if (data.chemicals) {
                this.chemicals = [];
                for (let i = 0; i < data.chemicals.length; i++) {
                    let item = data.chemicals[i];
                    this.chemicals[i] = item && !(item as any).toJSON ? new SimulationChemical(item) : item as SimulationChemical;
                }
            }
            this.defaults = data.defaults && !(data.defaults as any).toJSON ? new SimulationDefault(data.defaults) : this.defaults as SimulationDefault;
            if (data.expenses) {
                this.expenses = [];
                for (let i = 0; i < data.expenses.length; i++) {
                    let item = data.expenses[i];
                    this.expenses[i] = item && !(item as any).toJSON ? new SimulationExpense(item) : item as SimulationExpense;
                }
            }
            this.fluidSummary = data.fluidSummary && !(data.fluidSummary as any).toJSON ? new SimulationFluidSummary(data.fluidSummary) : this.fluidSummary as SimulationFluidSummary;
            this.goals = data.goals && !(data.goals as any).toJSON ? new SimulationGoals(data.goals) : this.goals as SimulationGoals;
            this.header = data.header && !(data.header as any).toJSON ? new SimulationHeader(data.header) : this.header as SimulationHeader;
            this.performance = data.performance && !(data.performance as any).toJSON ? new PerformanceSummary(data.performance) : this.performance as PerformanceSummary;
            this.siteDetails = data.siteDetails && !(data.siteDetails as any).toJSON ? new SimulationSiteDetails(data.siteDetails) : this.siteDetails as SimulationSiteDetails;
            this.wellInfo = data.wellInfo && !(data.wellInfo as any).toJSON ? new WellInfo(data.wellInfo) : this.wellInfo as WellInfo;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(SimulationActivity.fromJS(item));
            }
            if (Array.isArray(_data["chemicals"])) {
                this.chemicals = [] as any;
                for (let item of _data["chemicals"])
                    this.chemicals!.push(SimulationChemical.fromJS(item));
            }
            this.defaults = _data["defaults"] ? SimulationDefault.fromJS(_data["defaults"]) : undefined as any;
            if (Array.isArray(_data["expenses"])) {
                this.expenses = [] as any;
                for (let item of _data["expenses"])
                    this.expenses!.push(SimulationExpense.fromJS(item));
            }
            this.fluidSummary = _data["fluidSummary"] ? SimulationFluidSummary.fromJS(_data["fluidSummary"]) : undefined as any;
            this.goals = _data["goals"] ? SimulationGoals.fromJS(_data["goals"]) : undefined as any;
            this.header = _data["header"] ? SimulationHeader.fromJS(_data["header"]) : undefined as any;
            this.performance = _data["performance"] ? PerformanceSummary.fromJS(_data["performance"]) : undefined as any;
            this.siteDetails = _data["siteDetails"] ? SimulationSiteDetails.fromJS(_data["siteDetails"]) : undefined as any;
            this.wellInfo = _data["wellInfo"] ? WellInfo.fromJS(_data["wellInfo"]) : undefined as any;
        }
    }

    static override fromJS(data: any): Simulation {
        data = typeof data === 'object' ? data : {};
        let result = new Simulation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.chemicals)) {
            data["chemicals"] = [];
            for (let item of this.chemicals)
                data["chemicals"].push(item ? item.toJSON() : undefined as any);
        }
        data["defaults"] = this.defaults ? this.defaults.toJSON() : undefined as any;
        if (Array.isArray(this.expenses)) {
            data["expenses"] = [];
            for (let item of this.expenses)
                data["expenses"].push(item ? item.toJSON() : undefined as any);
        }
        data["fluidSummary"] = this.fluidSummary ? this.fluidSummary.toJSON() : undefined as any;
        data["goals"] = this.goals ? this.goals.toJSON() : undefined as any;
        data["header"] = this.header ? this.header.toJSON() : undefined as any;
        data["performance"] = this.performance ? this.performance.toJSON() : undefined as any;
        data["siteDetails"] = this.siteDetails ? this.siteDetails.toJSON() : undefined as any;
        data["wellInfo"] = this.wellInfo ? this.wellInfo.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISimulation extends IEntityBase {
    activities?: ISimulationActivity[] | undefined;
    chemicals?: ISimulationChemical[] | undefined;
    defaults?: ISimulationDefault | undefined;
    expenses?: ISimulationExpense[] | undefined;
    fluidSummary?: ISimulationFluidSummary | undefined;
    goals?: ISimulationGoals | undefined;
    header?: ISimulationHeader | undefined;
    performance?: IPerformanceSummary | undefined;
    siteDetails?: ISimulationSiteDetails | undefined;
    wellInfo?: IWellInfo | undefined;
}

export class SimulationActivity implements ISimulationActivity {
    guid?: string | undefined;
    activity?: string | undefined;
    isDepthStart!: boolean;
    isDepthEnd!: boolean;
    duration!: number;
    depthStart!: number;
    depthEnd!: number;
    circulationRate!: number;
    returnRate!: number;
    pipeSpeed!: number;

    constructor(data?: ISimulationActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.activity = _data["activity"];
            this.isDepthStart = _data["isDepthStart"];
            this.isDepthEnd = _data["isDepthEnd"];
            this.duration = _data["duration"];
            this.depthStart = _data["depthStart"];
            this.depthEnd = _data["depthEnd"];
            this.circulationRate = _data["circulationRate"];
            this.returnRate = _data["returnRate"];
            this.pipeSpeed = _data["pipeSpeed"];
        }
    }

    static fromJS(data: any): SimulationActivity {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["activity"] = this.activity;
        data["isDepthStart"] = this.isDepthStart;
        data["isDepthEnd"] = this.isDepthEnd;
        data["duration"] = this.duration;
        data["depthStart"] = this.depthStart;
        data["depthEnd"] = this.depthEnd;
        data["circulationRate"] = this.circulationRate;
        data["returnRate"] = this.returnRate;
        data["pipeSpeed"] = this.pipeSpeed;
        return data;
    }
}

export interface ISimulationActivity {
    guid?: string | undefined;
    activity?: string | undefined;
    isDepthStart: boolean;
    isDepthEnd: boolean;
    duration: number;
    depthStart: number;
    depthEnd: number;
    circulationRate: number;
    returnRate: number;
    pipeSpeed: number;
}

export class SimulationChemical implements ISimulationChemical {
    id?: string | undefined;
    chemicalId?: string | undefined;
    chemicalFluidSystemId?: string | undefined;
    dosage!: number;
    cost!: number;
    hasDepth!: boolean;
    depthOrPlug!: number;
    shutdownOnPooh!: boolean;

    constructor(data?: ISimulationChemical) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chemicalId = _data["chemicalId"];
            this.chemicalFluidSystemId = _data["chemicalFluidSystemId"];
            this.dosage = _data["dosage"];
            this.cost = _data["cost"];
            this.hasDepth = _data["hasDepth"];
            this.depthOrPlug = _data["depthOrPlug"];
            this.shutdownOnPooh = _data["shutdownOnPooh"];
        }
    }

    static fromJS(data: any): SimulationChemical {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationChemical();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chemicalId"] = this.chemicalId;
        data["chemicalFluidSystemId"] = this.chemicalFluidSystemId;
        data["dosage"] = this.dosage;
        data["cost"] = this.cost;
        data["hasDepth"] = this.hasDepth;
        data["depthOrPlug"] = this.depthOrPlug;
        data["shutdownOnPooh"] = this.shutdownOnPooh;
        return data;
    }
}

export interface ISimulationChemical {
    id?: string | undefined;
    chemicalId?: string | undefined;
    chemicalFluidSystemId?: string | undefined;
    dosage: number;
    cost: number;
    hasDepth: boolean;
    depthOrPlug: number;
    shutdownOnPooh: boolean;
}

export class SimulationDefault implements ISimulationDefault {
    duration!: number;
    pipeSpeed!: number;
    circulationRate!: number;
    returnRate!: number;

    constructor(data?: ISimulationDefault) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"];
            this.pipeSpeed = _data["pipeSpeed"];
            this.circulationRate = _data["circulationRate"];
            this.returnRate = _data["returnRate"];
        }
    }

    static fromJS(data: any): SimulationDefault {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationDefault();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["pipeSpeed"] = this.pipeSpeed;
        data["circulationRate"] = this.circulationRate;
        data["returnRate"] = this.returnRate;
        return data;
    }
}

export interface ISimulationDefault {
    duration: number;
    pipeSpeed: number;
    circulationRate: number;
    returnRate: number;
}

export class SimulationExpense implements ISimulationExpense {
    id?: string | undefined;
    description?: string | undefined;
    costPerFactor!: number;
    expenseCostFactorId?: string | undefined;

    constructor(data?: ISimulationExpense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.costPerFactor = _data["costPerFactor"];
            this.expenseCostFactorId = _data["expenseCostFactorId"];
        }
    }

    static fromJS(data: any): SimulationExpense {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationExpense();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["costPerFactor"] = this.costPerFactor;
        data["expenseCostFactorId"] = this.expenseCostFactorId;
        return data;
    }
}

export interface ISimulationExpense {
    id?: string | undefined;
    description?: string | undefined;
    costPerFactor: number;
    expenseCostFactorId?: string | undefined;
}

export class SimulationFluidSummary implements ISimulationFluidSummary {
    barrelCount!: number;
    costPerBbl!: number;
    fluidDensity!: number;
    fluidTypeId?: string | undefined;
    loopTypeId?: string | undefined;
    slwViscosity!: number;

    constructor(data?: ISimulationFluidSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barrelCount = _data["barrelCount"];
            this.costPerBbl = _data["costPerBbl"];
            this.fluidDensity = _data["fluidDensity"];
            this.fluidTypeId = _data["fluidTypeId"];
            this.loopTypeId = _data["loopTypeId"];
            this.slwViscosity = _data["slwViscosity"];
        }
    }

    static fromJS(data: any): SimulationFluidSummary {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationFluidSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barrelCount"] = this.barrelCount;
        data["costPerBbl"] = this.costPerBbl;
        data["fluidDensity"] = this.fluidDensity;
        data["fluidTypeId"] = this.fluidTypeId;
        data["loopTypeId"] = this.loopTypeId;
        data["slwViscosity"] = this.slwViscosity;
        return data;
    }
}

export interface ISimulationFluidSummary {
    barrelCount: number;
    costPerBbl: number;
    fluidDensity: number;
    fluidTypeId?: string | undefined;
    loopTypeId?: string | undefined;
    slwViscosity: number;
}

export class SimulationGoals implements ISimulationGoals {
    cost!: number;
    hours!: number;

    constructor(data?: ISimulationGoals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cost = _data["cost"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): SimulationGoals {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationGoals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cost"] = this.cost;
        data["hours"] = this.hours;
        return data;
    }
}

export interface ISimulationGoals {
    cost: number;
    hours: number;
}

export class SimulationSiteDetails implements ISimulationSiteDetails {
    wellName?: string | undefined;
    api?: string | undefined;
    districtId?: string | undefined;
    stateId?: string | undefined;
    countyId?: string | undefined;
    field?: string | undefined;
    procedure?: string | undefined;
    wellType?: string | undefined;

    constructor(data?: ISimulationSiteDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellName = _data["wellName"];
            this.api = _data["api"];
            this.districtId = _data["districtId"];
            this.stateId = _data["stateId"];
            this.countyId = _data["countyId"];
            this.field = _data["field"];
            this.procedure = _data["procedure"];
            this.wellType = _data["wellType"];
        }
    }

    static fromJS(data: any): SimulationSiteDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationSiteDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellName"] = this.wellName;
        data["api"] = this.api;
        data["districtId"] = this.districtId;
        data["stateId"] = this.stateId;
        data["countyId"] = this.countyId;
        data["field"] = this.field;
        data["procedure"] = this.procedure;
        data["wellType"] = this.wellType;
        return data;
    }
}

export interface ISimulationSiteDetails {
    wellName?: string | undefined;
    api?: string | undefined;
    districtId?: string | undefined;
    stateId?: string | undefined;
    countyId?: string | undefined;
    field?: string | undefined;
    procedure?: string | undefined;
    wellType?: string | undefined;
}

export class UnitConversionInfo implements IUnitConversionInfo {
    name?: string | undefined;
    abbreviation?: string | undefined;
    conversionFactor!: number;

    constructor(data?: IUnitConversionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.abbreviation = _data["abbreviation"];
            this.conversionFactor = _data["conversionFactor"];
        }
    }

    static fromJS(data: any): UnitConversionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UnitConversionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["abbreviation"] = this.abbreviation;
        data["conversionFactor"] = this.conversionFactor;
        return data;
    }
}

export interface IUnitConversionInfo {
    name?: string | undefined;
    abbreviation?: string | undefined;
    conversionFactor: number;
}

export class User extends EntityBase implements IUser {
    email?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    contactNumber?: string | undefined;
    isEmployee!: boolean;
    role?: string | undefined;
    companyIds?: string[] | undefined;
    hasAllCompany!: boolean;
    isGlobalAdmin!: boolean;
    grafanaUserId!: number;
    azureObjectId?: string | undefined;
    companyRoles?: CompanyRole[] | undefined;
    companyJobTitle?: string | undefined;

    constructor(data?: IUser) {
        super(data);
        if (data) {
            if (data.companyRoles) {
                this.companyRoles = [];
                for (let i = 0; i < data.companyRoles.length; i++) {
                    let item = data.companyRoles[i];
                    this.companyRoles[i] = item && !(item as any).toJSON ? new CompanyRole(item) : item as CompanyRole;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.contactNumber = _data["contactNumber"];
            this.isEmployee = _data["isEmployee"];
            this.role = _data["role"];
            if (Array.isArray(_data["companyIds"])) {
                this.companyIds = [] as any;
                for (let item of _data["companyIds"])
                    this.companyIds!.push(item);
            }
            this.hasAllCompany = _data["hasAllCompany"];
            this.isGlobalAdmin = _data["isGlobalAdmin"];
            this.grafanaUserId = _data["grafanaUserId"];
            this.azureObjectId = _data["azureObjectId"];
            if (Array.isArray(_data["companyRoles"])) {
                this.companyRoles = [] as any;
                for (let item of _data["companyRoles"])
                    this.companyRoles!.push(CompanyRole.fromJS(item));
            }
            this.companyJobTitle = _data["companyJobTitle"];
        }
    }

    static override fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["contactNumber"] = this.contactNumber;
        data["isEmployee"] = this.isEmployee;
        data["role"] = this.role;
        if (Array.isArray(this.companyIds)) {
            data["companyIds"] = [];
            for (let item of this.companyIds)
                data["companyIds"].push(item);
        }
        data["hasAllCompany"] = this.hasAllCompany;
        data["isGlobalAdmin"] = this.isGlobalAdmin;
        data["grafanaUserId"] = this.grafanaUserId;
        data["azureObjectId"] = this.azureObjectId;
        if (Array.isArray(this.companyRoles)) {
            data["companyRoles"] = [];
            for (let item of this.companyRoles)
                data["companyRoles"].push(item ? item.toJSON() : undefined as any);
        }
        data["companyJobTitle"] = this.companyJobTitle;
        super.toJSON(data);
        return data;
    }
}

export interface IUser extends IEntityBase {
    email?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    contactNumber?: string | undefined;
    isEmployee: boolean;
    role?: string | undefined;
    companyIds?: string[] | undefined;
    hasAllCompany: boolean;
    isGlobalAdmin: boolean;
    grafanaUserId: number;
    azureObjectId?: string | undefined;
    companyRoles?: ICompanyRole[] | undefined;
    companyJobTitle?: string | undefined;
}

export class CompanyRole implements ICompanyRole {
    companyId?: string | undefined;
    role?: string | undefined;
    companyAssociationRequestId?: string | undefined;

    constructor(data?: ICompanyRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.role = _data["role"];
            this.companyAssociationRequestId = _data["companyAssociationRequestId"];
        }
    }

    static fromJS(data: any): CompanyRole {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["role"] = this.role;
        data["companyAssociationRequestId"] = this.companyAssociationRequestId;
        return data;
    }
}

export interface ICompanyRole {
    companyId?: string | undefined;
    role?: string | undefined;
    companyAssociationRequestId?: string | undefined;
}

export class UserInfo implements IUserInfo {
    upn?: string | undefined;
    login?: string | undefined;
    username?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.upn = _data["upn"];
            this.login = _data["login"];
            this.username = _data["username"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upn"] = this.upn;
        data["login"] = this.login;
        data["username"] = this.username;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IUserInfo {
    upn?: string | undefined;
    login?: string | undefined;
    username?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
}

export class UserNameViewModel implements IUserNameViewModel {
    userId?: string | undefined;
    userName?: string | undefined;

    constructor(data?: IUserNameViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): UserNameViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserNameViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IUserNameViewModel {
    userId?: string | undefined;
    userName?: string | undefined;
}

export class TableEntity implements ITableEntity {
    partitionKey?: string | undefined;
    rowKey?: string | undefined;
    timestamp!: Date;
    eTag?: string | undefined;

    constructor(data?: ITableEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partitionKey = _data["partitionKey"];
            this.rowKey = _data["rowKey"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            this.eTag = _data["eTag"];
        }
    }

    static fromJS(data: any): TableEntity {
        data = typeof data === 'object' ? data : {};
        let result = new TableEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partitionKey"] = this.partitionKey;
        data["rowKey"] = this.rowKey;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        data["eTag"] = this.eTag;
        return data;
    }
}

export interface ITableEntity {
    partitionKey?: string | undefined;
    rowKey?: string | undefined;
    timestamp: Date;
    eTag?: string | undefined;
}

export class WorkbookConfiguration extends TableEntity implements IWorkbookConfiguration {
    id?: string | undefined;
    job_number?: string | undefined;
    availableFields?: string[] | undefined;
    displayFields?: string[] | undefined;
    customFields?: Configuration[] | undefined;

    constructor(data?: IWorkbookConfiguration) {
        super(data);
        if (data) {
            if (data.customFields) {
                this.customFields = [];
                for (let i = 0; i < data.customFields.length; i++) {
                    let item = data.customFields[i];
                    this.customFields[i] = item && !(item as any).toJSON ? new Configuration(item) : item as Configuration;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.job_number = _data["job_number"];
            if (Array.isArray(_data["availableFields"])) {
                this.availableFields = [] as any;
                for (let item of _data["availableFields"])
                    this.availableFields!.push(item);
            }
            if (Array.isArray(_data["displayFields"])) {
                this.displayFields = [] as any;
                for (let item of _data["displayFields"])
                    this.displayFields!.push(item);
            }
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(Configuration.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): WorkbookConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookConfiguration();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["job_number"] = this.job_number;
        if (Array.isArray(this.availableFields)) {
            data["availableFields"] = [];
            for (let item of this.availableFields)
                data["availableFields"].push(item);
        }
        if (Array.isArray(this.displayFields)) {
            data["displayFields"] = [];
            for (let item of this.displayFields)
                data["displayFields"].push(item);
        }
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWorkbookConfiguration extends ITableEntity {
    id?: string | undefined;
    job_number?: string | undefined;
    availableFields?: string[] | undefined;
    displayFields?: string[] | undefined;
    customFields?: IConfiguration[] | undefined;
}

export class Configuration implements IConfiguration {
    name?: string | undefined;
    display!: boolean;
    isText!: boolean;

    constructor(data?: IConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.display = _data["display"];
            this.isText = _data["isText"];
        }
    }

    static fromJS(data: any): Configuration {
        data = typeof data === 'object' ? data : {};
        let result = new Configuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["display"] = this.display;
        data["isText"] = this.isText;
        return data;
    }
}

export interface IConfiguration {
    name?: string | undefined;
    display: boolean;
    isText: boolean;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}